<template>
  <NotFound v-if="typeCheck === 'error'" />
  <main class="main-content-area" v-else-if="this.gamespageData">
    <template
      v-if="
        !(
          this.gamespageData.meta &&
          this.gamespageData.meta.enable_different_free_game_url_for_mobile
        )
      "
    >
      <div
        class="rotate-msg"
        id="rotate-msg"
        v-if="!showData"
        :style="{
          '--primary-bg': $root.color_schema.primary,
          '--primary-color': getContrastYIQ($root.color_schema.primary)
            ? '#333'
            : '#fff',
        }"
      >
        <span class="rotate-svg">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            id="phoneIcon"
            viewBox="0 0 100 180"
          >
            <g id="Layer_2" data-name="Layer 2">
              <g id="Layer_1-2" data-name="Layer 1">
                <path
                  class="cls-1"
                  d="M90,0H10A10,10,0,0,0,0,10V170a10,10,0,0,0,10,10H90a10,10,0,0,0,10-10V10A10,10,0,0,0,90,0ZM4,24.51H96V150H4ZM10,4H90a6,6,0,0,1,6,6V20.51H4V10A6,6,0,0,1,10,4ZM90,176H10a6,6,0,0,1-6-6V154H96v16A6,6,0,0,1,90,176Z"
                />
                <path
                  class="cls-1"
                  d="M40.63,14.25H59.37a2,2,0,1,0,0-4H40.63a2,2,0,0,0,0,4Z"
                />
                <path
                  class="cls-1"
                  d="M50,159.8a5.2,5.2,0,1,0,5.2,5.2A5.2,5.2,0,0,0,50,159.8Zm0,6.4a1.2,1.2,0,1,1,1.2-1.2A1.2,1.2,0,0,1,50,166.2Z"
                />
              </g>
            </g>
          </svg>
        </span>
        <span>{{ $root.i18n.please_turn_your_phone_to_enjoy_the_game }}</span>
        <button
          class="cta cta-secondary cta-promotion cta-large cta-lg-br back-btn"
          @click="showData = true"
        >
          {{ $root.i18n.go_back }}
        </button>
      </div>
    </template>

    <!-- Game banner section -->
    <section
      v-if="this.gamespageData.meta && this.gamespageData.meta.banner_image"
      class="ct-inner-banner pt-26"
      :style="{
        background:
          this.gamespageData.meta && this.gamespageData.meta.banner_image
            ? $root.color_schema.footer_bg
            : 'none',
      }"
    >
      <div class="container z-con">
        <!--Breadcrumps-->
        <div class="col-md-12">
          <Breadcrumb
            :breadcrumbData="this.gamespageData.breadcrumb"
            :dark="getContrastYIQ($root.color_schema.footer_bg)"
          />
        </div>
      </div>
      <!--End Breadcrumps:templateName="this.gameTemplate"
            :gameBlockTitle="
              gamesTop3 &&
              gamesTop3.length > 0 &&
              gamesTop3[0] &&
              gamesTop3[0].length > 0
                ? gamesTop3Title[0]
                : ''
            "-->
      <template v-if="Object.keys(introblockData).length > 0">
        <IntroBlock :introBlockData="introblockData" :pageName="'game'" />
      </template>
      <div class="container z-con">
        <div
          :class="{
            row: !this.gameTemplate,
            'games-banner-block': this.gameTemplate,
          }"
          v-if="this.gamespageData.meta && this.gamespageData.meta.banner_image"
        >
          <div
            :class="[
              this.gameTemplate ? '' : 'col-md-8',
              'ct-inner-banner-lft',
              (this.gamespageData.meta.play_with_live_dealer &&
                this.gamespageData.meta.play_with_live_dealer.banner) ||
              (this.gamespageData.meta &&
                this.gamespageData.meta.our_expert_review &&
                Object.keys(this.gamespageData.meta.our_expert_review).length >
                  0 &&
                this.gamespageData.meta.our_expert_review.reviewer_image)
                ? ''
                : 'banner-wd',
              !this.gameTemplate ||
              (this.gameTemplate &&
                gamesTop3 &&
                gamesTop3.length > 0 &&
                gamesTop3[0] &&
                gamesTop3[0].length > 0)
                ? ''
                : 'banner-wd',
            ]"
          >
            <div
              :class="{
                'game-space': true,
                'game-left':
                  this.gameTemplate &&
                  gamesTop3 &&
                  gamesTop3.length > 0 &&
                  gamesTop3[0] &&
                  gamesTop3[0].length > 0,
              }"
              v-if="showData"
            >
              <template v-if="hideToplistLabelGB"> </template>
              <template v-else>
                <a
                  v-if="
                    this.gamespageData.meta.geo_provider_partners_data &&
                    this.gamespageData.meta.geo_provider_partners_data
                      .current &&
                    this.gamespageData.meta.geo_provider_partners_data.current
                      .go_link
                  "
                  :title="
                    this.gamespageData.meta.geo_provider_partners_data.current
                      .product_name
                  "
                  :href="
                    getGoLink(
                      this.gamespageData.meta.geo_provider_partners_data.current
                        .go_link,
                      this.gamespageData.meta.geo_provider_partners_data.current
                        .slug
                    )
                  "
                  class="bg-link cas-link"
                  target="_blank"
                  :rel="
                    $root.change_cta_to_sponsored
                      ? 'nofollow sponsored'
                      : 'nofollow'
                  "
                />
              </template>
              <img
                :class="{
                  'banner-img-im':
                    !this.gameTemplate ||
                    !(
                      this.gameTemplate &&
                      gamesTop3 &&
                      gamesTop3.length > 0 &&
                      gamesTop3[0] &&
                      gamesTop3[0].length > 0
                    ),
                  'banner-img':
                    this.gameTemplate &&
                    gamesTop3 &&
                    gamesTop3.length > 0 &&
                    gamesTop3[0] &&
                    gamesTop3[0].length > 0,
                  'game-left':
                    this.gameTemplate &&
                    gamesTop3 &&
                    gamesTop3.length > 0 &&
                    gamesTop3[0] &&
                    gamesTop3[0].length > 0,
                }"
                v-if="$root.enable_lazyload"
                v-lazy="this.gamespageData.meta.banner_image"
                width="860"
                height="557"
                alt="Banner Image"
              />
              <img
                :class="{
                  'banner-img-im':
                    !this.gameTemplate ||
                    !(
                      this.gameTemplate &&
                      gamesTop3 &&
                      gamesTop3.length > 0 &&
                      gamesTop3[0] &&
                      gamesTop3[0].length > 0
                    ),
                  'banner-img':
                    this.gameTemplate &&
                    gamesTop3 &&
                    gamesTop3.length > 0 &&
                    gamesTop3[0] &&
                    gamesTop3[0].length > 0,
                  'game-left':
                    this.gameTemplate &&
                    gamesTop3 &&
                    gamesTop3.length > 0 &&
                    gamesTop3[0] &&
                    gamesTop3[0].length > 0,
                }"
                v-else
                :src="this.gamespageData.meta.banner_image"
                width="860"
                height="557"
                alt="Banner Image"
              />
              <div class="game-space-content">
                <div
                  class="game-logo"
                  v-if="
                    !$root.disable_freegame_banner_outlink &&
                    this.gamespageData.meta.geo_provider_partners_data &&
                    this.gamespageData.meta.geo_provider_partners_data.current
                  "
                >
                  <template v-if="hideToplistLabelGB"> </template>
                  <template v-else>
                    <a
                      :title="
                        this.gamespageData.meta.geo_provider_partners_data
                          .current.product_name
                      "
                      :href="
                        getGoLink(
                          this.gamespageData.meta.geo_provider_partners_data
                            .current.go_link,
                          this.gamespageData.meta.geo_provider_partners_data
                            .current.slug
                        )
                      "
                      class="partner-logo cas-link gam-strp"
                      target="_blank"
                      :rel="
                        $root.change_cta_to_sponsored
                          ? 'nofollow sponsored'
                          : 'nofollow'
                      "
                    >
                      <img
                        v-if="
                          $root.enable_lazyload &&
                          assets_images &&
                          assets_images.pro_asset_sizes &&
                          this.gamespageData.meta.geo_provider_partners_data
                            .current.product_assets.length > 0
                        "
                        v-lazy="
                          this.gamespageData.meta.geo_provider_partners_data.current.product_assets.filter(
                            (ele) =>
                              ele.asset_category_name ===
                              assets_images.pro_asset_sizes.medium
                          ).length > 0
                            ? this.gamespageData.meta.geo_provider_partners_data.current.product_assets
                                .filter(
                                  (ele) =>
                                    ele.asset_category_name ===
                                    assets_images.pro_asset_sizes.medium
                                )
                                .shift().url
                            : ''
                        "
                        width="136"
                        height="136"
                        :alt="
                          getAltText(
                            this.gamespageData.meta.geo_provider_partners_data
                              .current.product_name,
                            this.gamespageData.meta.geo_provider_partners_data.current.product_assets.filter(
                              (ele) =>
                                ele.asset_category_name ===
                                assets_images.pro_asset_sizes.medium
                            ).length > 0
                              ? this.gamespageData.meta.geo_provider_partners_data.current.product_assets
                                  .filter(
                                    (ele) =>
                                      ele.asset_category_name ===
                                      assets_images.pro_asset_sizes.medium
                                  )
                                  .shift().url
                              : ''
                          )
                        "
                      />
                      <img
                        v-else-if="
                          assets_images &&
                          assets_images.pro_asset_sizes &&
                          this.gamespageData.meta.geo_provider_partners_data
                            .current.product_assets.length > 0
                        "
                        :src="
                          this.gamespageData.meta.geo_provider_partners_data.current.product_assets.filter(
                            (ele) =>
                              ele.asset_category_name ===
                              assets_images.pro_asset_sizes.medium
                          ).length > 0
                            ? this.gamespageData.meta.geo_provider_partners_data.current.product_assets
                                .filter(
                                  (ele) =>
                                    ele.asset_category_name ===
                                    assets_images.pro_asset_sizes.medium
                                )
                                .shift().url
                            : $root.site_url + $root.asset_path + '/failure.png'
                        "
                        width="136"
                        height="136"
                        :alt="
                          getAltText(
                            this.gamespageData.meta.geo_provider_partners_data
                              .current.product_name,
                            this.gamespageData.meta.geo_provider_partners_data.current.product_assets.filter(
                              (ele) =>
                                ele.asset_category_name ===
                                assets_images.pro_asset_sizes.medium
                            ).length > 0
                              ? this.gamespageData.meta.geo_provider_partners_data.current.product_assets
                                  .filter(
                                    (ele) =>
                                      ele.asset_category_name ===
                                      assets_images.pro_asset_sizes.medium
                                  )
                                  .shift().url
                              : $root.site_url +
                                  $root.asset_path +
                                  '/failure.png'
                          )
                        "
                      />
                      <div class="partner-hover wd-gam-bann">
                        <div
                          class="partner-hover-inner"
                          :style="{
                            '--primary-btn': $root.color_schema.primary_btn,
                            '--primary-btn-hover': pSBC(
                              -0.2,
                              $root.color_schema.primary_btn
                            ),
                          }"
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="10"
                            height="16"
                            viewBox="0 0 10 16"
                            fill="none"
                          >
                            <path
                              d="M9.44469 7.37568L2.32449 0.255608C2.15981 0.090796 1.93997 0 1.70557 0C1.47116 0 1.25133 0.090796 1.08664 0.255608L0.562291 0.779831C0.22109 1.12142 0.22109 1.6766 0.562291 2.01767L6.5413 7.99668L0.555657 13.9823C0.390975 14.1471 0.300049 14.3668 0.300049 14.6011C0.300049 14.8357 0.390975 15.0554 0.555657 15.2203L1.08001 15.7444C1.24482 15.9092 1.46453 16 1.69893 16C1.93334 16 2.15317 15.9092 2.31785 15.7444L9.44469 8.61782C9.60976 8.45248 9.70043 8.23174 9.69991 7.99707C9.70043 7.7615 9.60976 7.54088 9.44469 7.37568Z"
                              fill="white"
                            />
                          </svg>
                        </div>
                      </div>
                      <div
                        class="stripe-gam"
                        v-if="
                          Object.keys(
                            hasTag(
                              this.gamespageData.meta.geo_provider_partners_data
                                .current.tags
                            )
                          ).length > 0
                        "
                        :style="{
                          backgroundColor:
                            Object.keys(
                              hasTag(
                                this.gamespageData.meta
                                  .geo_provider_partners_data.current.tags
                              )
                            ).length > 0
                              ? hasTag(
                                  this.gamespageData.meta
                                    .geo_provider_partners_data.current.tags
                                ).color
                              : null,
                        }"
                      >
                        <span
                          :class="{
                            'custom-font-2': true,
                            'text-gray': getContrastYIQ(
                              Object.keys(
                                hasTag(
                                  this.gamespageData.meta
                                    .geo_provider_partners_data.current.tags
                                )
                              ).length > 0
                                ? hasTag(
                                    this.gamespageData.meta
                                      .geo_provider_partners_data.current.tags
                                  ).color
                                : null
                            ),
                            'text-light': !getContrastYIQ(
                              Object.keys(
                                hasTag(
                                  this.gamespageData.meta
                                    .geo_provider_partners_data.current.tags
                                )
                              ).length > 0
                                ? hasTag(
                                    this.gamespageData.meta
                                      .geo_provider_partners_data.current.tags
                                  ).color
                                : null
                            ),
                          }"
                        >
                          <img
                            :src="
                              hasTag(
                                this.gamespageData.meta
                                  .geo_provider_partners_data.current.tags
                              ).icon
                            "
                            width="18"
                            height="12"
                            alt="tag-icons"
                          />
                          {{
                            titleCase(
                              hasTag(
                                this.gamespageData.meta
                                  .geo_provider_partners_data.current.tags
                              ).tag_name
                            )
                          }}
                        </span>
                      </div>
                    </a>
                  </template>
                </div>
                <div class="button-block">
                  <template v-if="!$root.disable_freegame_banner_outlink">
                    <template v-if="hideToplistLabelGB"> </template>
                    <template v-else>
                      <a
                        v-if="
                          this.gamespageData.meta.geo_provider_partners_data &&
                          this.gamespageData.meta.geo_provider_partners_data
                            .current
                        "
                        :title="
                          this.gamespageData.meta.geo_provider_partners_data
                            .current.product_name
                        "
                        :href="
                          getGoLink(
                            this.gamespageData.meta.geo_provider_partners_data
                              .current.go_link,
                            this.gamespageData.meta.geo_provider_partners_data
                              .current.slug
                          )
                        "
                        :class="{
                          'cta cta-primary cta-promotion custom-btn cas-link hover-btn ': true,
                          'text-white game-btn':
                            !$root.override_ctabtntxt_color &&
                            !getContrastYIQ($root.color_schema.primary_btn),
                          'text-gray':
                            !$root.override_ctabtntxt_color &&
                            getContrastYIQ($root.color_schema.primary_btn),
                          'text-cta-override': $root.override_ctabtntxt_color,
                        }"
                        target="_blank"
                        :rel="
                          $root.change_cta_to_sponsored
                            ? 'nofollow sponsored'
                            : 'nofollow'
                        "
                        :style="{
                          '--primary-btn': $root.color_schema.primary_btn,
                          '--primary-btn-hover': pSBC(
                            -0.2,
                            $root.color_schema.primary_btn
                          ),
                        }"
                        ><span class="cta-text">{{
                          this.gamespageData.meta.play_for_real_label
                        }}</span
                        ><span
                          class="hover-text"
                          v-for="(char, indexGo) in $root.i18n.go_to_casino"
                          :key="indexGo + `gambpp`"
                          >{{ char }}</span
                        >
                      </a>
                    </template>
                  </template>
                  <a
                    :title="this.gamespageData.meta.play_for_free_label"
                    v-if="checkPlayFreeButton()"
                    href="javascript:void(0)"
                    class="cta cta-primary cta-promotion cta-outline"
                    @click="showIframe()"
                    >{{ this.gamespageData.meta.play_for_free_label }}</a
                  >
                </div>
              </div>
            </div>
            <div class="game-space" v-else>
              <!-- Sticky Top -->
              <template v-if="!$root.disable_freegame_banner_outlink">
                <template v-if="hideToplistLabelGB"> </template>
                <template v-else>
                  <a
                    v-if="
                      this.gamespageData.meta.geo_provider_partners_data &&
                      this.gamespageData.meta.geo_provider_partners_data.current
                    "
                    :title="
                      this.gamespageData.meta.geo_provider_partners_data.current
                        .product_name
                    "
                    :href="
                      getGoLink(
                        this.gamespageData.meta.geo_provider_partners_data
                          .current.go_link,
                        this.gamespageData.meta.geo_provider_partners_data
                          .current.slug
                      )
                    "
                    class="game_review_flex cas-link"
                    id="game_review_flex"
                    :rel="
                      $root.change_cta_to_sponsored
                        ? 'nofollow sponsored'
                        : 'nofollow'
                    "
                    target="_blank"
                  >
                    <div class="sticky-review-card">
                      <div class="sticky-inner-wrapper">
                        <a
                          :title="
                            this.gamespageData.meta.geo_provider_partners_data
                              .current.product_name
                          "
                          :href="
                            getGoLink(
                              this.gamespageData.meta.geo_provider_partners_data
                                .current.go_link,
                              this.gamespageData.meta.geo_provider_partners_data
                                .current.slug
                            )
                          "
                          class="affliate-logo partner-logo cas-link"
                          :rel="
                            $root.change_cta_to_sponsored
                              ? 'nofollow sponsored'
                              : 'nofollow'
                          "
                          target="_blank"
                        >
                          <img
                            v-if="
                              $root.enable_lazyload &&
                              assets_images &&
                              assets_images.pro_asset_sizes
                            "
                            v-lazy="
                              this.gamespageData.meta.geo_provider_partners_data.current.product_assets.filter(
                                (ele) =>
                                  ele.asset_category_name ===
                                  assets_images.pro_asset_sizes.large
                              ).length > 0
                                ? this.gamespageData.meta.geo_provider_partners_data.current.product_assets
                                    .filter(
                                      (ele) =>
                                        ele.asset_category_name ===
                                        assets_images.pro_asset_sizes.large
                                    )
                                    .shift().url
                                : ''
                            "
                            width="65"
                            height="65"
                            :alt="
                              getAltText(
                                this.gamespageData.meta
                                  .geo_provider_partners_data.current
                                  .product_name,
                                this.gamespageData.meta.geo_provider_partners_data.current.product_assets.filter(
                                  (ele) =>
                                    ele.asset_category_name ===
                                    assets_images.pro_asset_sizes.large
                                ).length > 0
                                  ? this.gamespageData.meta.geo_provider_partners_data.current.product_assets
                                      .filter(
                                        (ele) =>
                                          ele.asset_category_name ===
                                          assets_images.pro_asset_sizes.large
                                      )
                                      .shift().url
                                  : ''
                              )
                            "
                          />
                          <img
                            v-else-if="
                              assets_images && assets_images.pro_asset_sizes
                            "
                            :src="
                              this.gamespageData.meta.geo_provider_partners_data.current.product_assets.filter(
                                (ele) =>
                                  ele.asset_category_name ===
                                  assets_images.pro_asset_sizes.large
                              ).length > 0
                                ? this.gamespageData.meta.geo_provider_partners_data.current.product_assets
                                    .filter(
                                      (ele) =>
                                        ele.asset_category_name ===
                                        assets_images.pro_asset_sizes.large
                                    )
                                    .shift().url
                                : $root.site_url +
                                  $root.asset_path +
                                  '/failure.png'
                            "
                            width="65"
                            height="65"
                            :alt="
                              getAltText(
                                this.gamespageData.meta
                                  .geo_provider_partners_data.current
                                  .product_name,
                                this.gamespageData.meta.geo_provider_partners_data.current.product_assets.filter(
                                  (ele) =>
                                    ele.asset_category_name ===
                                    assets_images.pro_asset_sizes.large
                                ).length > 0
                                  ? this.gamespageData.meta.geo_provider_partners_data.current.product_assets
                                      .filter(
                                        (ele) =>
                                          ele.asset_category_name ===
                                          assets_images.pro_asset_sizes.large
                                      )
                                      .shift().url
                                  : $root.site_url +
                                      $root.asset_path +
                                      '/failure.png'
                              )
                            "
                          />
                          <div class="partner-hover wd-gam-stick">
                            <div
                              class="partner-hover-inner"
                              :style="{
                                '--primary-btn': $root.color_schema.primary_btn,
                                '--primary-btn-hover': pSBC(
                                  -0.2,
                                  $root.color_schema.primary_btn
                                ),
                              }"
                            >
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="10"
                                height="16"
                                viewBox="0 0 10 16"
                                fill="none"
                              >
                                <path
                                  d="M9.44469 7.37568L2.32449 0.255608C2.15981 0.090796 1.93997 0 1.70557 0C1.47116 0 1.25133 0.090796 1.08664 0.255608L0.562291 0.779831C0.22109 1.12142 0.22109 1.6766 0.562291 2.01767L6.5413 7.99668L0.555657 13.9823C0.390975 14.1471 0.300049 14.3668 0.300049 14.6011C0.300049 14.8357 0.390975 15.0554 0.555657 15.2203L1.08001 15.7444C1.24482 15.9092 1.46453 16 1.69893 16C1.93334 16 2.15317 15.9092 2.31785 15.7444L9.44469 8.61782C9.60976 8.45248 9.70043 8.23174 9.69991 7.99707C9.70043 7.7615 9.60976 7.54088 9.44469 7.37568Z"
                                  fill="white"
                                />
                              </svg>
                            </div>
                          </div>
                        </a>
                        <span class="sticky-text stick-part-1">
                          <span
                            class="sticky-title text-hover"
                            style="font-size: 1.175rem; font-weight: 700"
                            >{{
                              this.gamespageData.meta.geo_provider_partners_data
                                .current.product_name
                            }}</span
                          >
                          <span class="bonus-text">
                            <div class="pt-6px">
                              <div
                                :class="{
                                  'top-choice-card': true,
                                  'font-dark': getContrastYIQ(
                                    Object.keys(
                                      hasTag(
                                        this.gamespageData.meta
                                          .geo_provider_partners_data.current
                                          .tags
                                      )
                                    ).length > 0
                                      ? hasTag(
                                          this.gamespageData.meta
                                            .geo_provider_partners_data.current
                                            .tags
                                        ).color
                                      : null
                                  ),
                                  'font-light': !getContrastYIQ(
                                    Object.keys(
                                      hasTag(
                                        this.gamespageData.meta
                                          .geo_provider_partners_data.current
                                          .tags
                                      )
                                    ).length > 0
                                      ? hasTag(
                                          this.gamespageData.meta
                                            .geo_provider_partners_data.current
                                            .tags
                                        ).color
                                      : null
                                  ),
                                }"
                                v-if="
                                  Object.keys(
                                    hasTag(
                                      this.gamespageData.meta
                                        .geo_provider_partners_data.current.tags
                                    )
                                  ).length > 0
                                "
                                :style="{
                                  backgroundColor:
                                    Object.keys(
                                      hasTag(
                                        this.gamespageData.meta
                                          .geo_provider_partners_data.current
                                          .tags
                                      )
                                    ).length > 0
                                      ? hasTag(
                                          this.gamespageData.meta
                                            .geo_provider_partners_data.current
                                            .tags
                                        ).color
                                      : null,
                                }"
                              >
                                <img
                                  :src="
                                    hasTag(
                                      this.gamespageData.meta
                                        .geo_provider_partners_data.current.tags
                                    ).icon
                                  "
                                  width="18"
                                  height="12"
                                  alt="tag-icons"
                                />
                                {{
                                  titleCase(
                                    hasTag(
                                      this.gamespageData.meta
                                        .geo_provider_partners_data.current.tags
                                    ).tag_name
                                  )
                                }}
                              </div>
                            </div>
                          </span>
                        </span>
                        <span
                          class="sticky-text text-hover stick-part-2"
                          style="margin: auto"
                        >
                          <span class="bonus-text"
                            >{{
                              getPartnerGlobalString(
                                $root.i18n.get_best_bonus_for_this_game,
                                this.gamespageData.meta
                                  .geo_provider_partners_data.current
                                  .product_name
                              )
                            }}!</span
                          >
                          <div
                            class="termsgam"
                            v-if="
                              this.gamespageData.meta.geo_provider_partners_data
                                .current.bonus_tc &&
                              this.gamespageData.meta.geo_provider_partners_data
                                .current.bonus_tc != ''
                            "
                            v-html="
                              this.gamespageData.meta.geo_provider_partners_data
                                .current.bonus_tc
                            "
                            :style="{
                              '--primary-btn': $root.color_schema.primary_btn,
                            }"
                          ></div>
                          <span
                            class="card-stroke"
                            v-if="
                              this.gamespageData.meta.geo_provider_partners_data
                                .current.bonus_tc &&
                              this.gamespageData.meta.geo_provider_partners_data
                                .current.terms &&
                              this.gamespageData.meta.geo_provider_partners_data
                                .current.bonus_tc != '' &&
                              this.gamespageData.meta.geo_provider_partners_data
                                .current.terms != ''
                            "
                            >|</span
                          >
                          <a
                            :rel="
                              $root.change_cta_to_sponsored
                                ? 'nofollow sponsored'
                                : 'nofollow'
                            "
                            class="terms_tc cas-term"
                            v-if="
                              this.gamespageData.meta.geo_provider_partners_data
                                .current.terms &&
                              this.gamespageData.meta.geo_provider_partners_data
                                .current.terms != ''
                            "
                            :title="
                              this.gamespageData.meta.geo_provider_partners_data
                                .current.product_name
                            "
                            :href="
                              getGoLink(
                                this.gamespageData.meta
                                  .geo_provider_partners_data.current.term_link,
                                this.gamespageData.meta
                                  .geo_provider_partners_data.current.slug
                              )
                            "
                            target="_blank"
                            >{{
                              this.gamespageData.meta.geo_provider_partners_data
                                .current.terms
                            }}</a
                          >
                        </span>
                        <a
                          :title="
                            this.gamespageData.meta.geo_provider_partners_data
                              .current.product_name
                          "
                          :href="
                            getGoLink(
                              this.gamespageData.meta.geo_provider_partners_data
                                .current.go_link,
                              this.gamespageData.meta.geo_provider_partners_data
                                .current.slug
                            )
                          "
                          :class="{
                            'cta cta-primary cta-promotion cta-promo-review sticky-play-btn custom-btn hover-btn cas-link': true,
                            'text-white':
                              !$root.override_ctabtntxt_color &&
                              !getContrastYIQ($root.color_schema.primary_btn),
                            'text-gray':
                              !$root.override_ctabtntxt_color &&
                              getContrastYIQ($root.color_schema.primary_btn),
                            'text-cta-override': $root.override_ctabtntxt_color,
                          }"
                          target="_blank"
                          :rel="
                            $root.change_cta_to_sponsored
                              ? 'nofollow sponsored'
                              : 'nofollow'
                          "
                          :style="{
                            '--primary-btn': $root.color_schema.primary_btn,
                            '--primary-btn-hover': pSBC(
                              -0.2,
                              $root.color_schema.primary_btn
                            ),
                          }"
                          ><span class="cta-text">{{
                            this.gamespageData.meta.geo_provider_partners_data
                              .current.cta_button_text
                          }}</span
                          ><span
                            class="hover-text"
                            v-for="(char, indexGo) in $root.i18n.go_to_casino"
                            :key="indexGo + `gambspp`"
                            >{{ char }}</span
                          ></a
                        >
                      </div>
                    </div>
                  </a>
                </template>
              </template>
              <!-- Sticky Top End -->
              <template
                v-if="
                  !(
                    this.gamespageData.meta &&
                    this.gamespageData.meta
                      .enable_different_free_game_url_for_mobile
                  )
                "
              >
                <fullscreen ref="fullscreen">
                  <div
                    :class="{
                      'wrapper-iframe': true,
                      'wrapper-game-iframe':
                        this.gameTemplate &&
                        gamesTop3 &&
                        gamesTop3.length > 0 &&
                        gamesTop3[0] &&
                        gamesTop3[0].length > 0,
                    }"
                    id="wrapper-iframe"
                  >
                    <iframe
                      class="cas-iframe"
                      id="cas-iframe"
                      :src="this.gamespageData.meta.play_for_free_url"
                      @load="openFullscreen()"
                    ></iframe>
                  </div>
                  <div
                    v-if="
                      !$root.disable_freegame_banner_outlink &&
                      gameOverlay &&
                      this.gamespageData.meta.geo_provider_partners_data &&
                      this.gamespageData.meta.geo_provider_partners_data.current
                    "
                    class="cta-overlay"
                    :style="{
                      'background-color': color,
                      '--primary-color': getContrastYIQ('#060236')
                        ? '#333'
                        : '#fff',
                    }"
                  >
                    <template v-if="hideToplistLabelGB"> </template>
                    <template v-else>
                      <a
                        v-if="
                          this.gamespageData.meta.geo_provider_partners_data &&
                          this.gamespageData.meta.geo_provider_partners_data
                            .current &&
                          this.gamespageData.meta.geo_provider_partners_data
                            .current.go_link
                        "
                        :title="
                          this.gamespageData.meta.geo_provider_partners_data
                            .current.product_name
                        "
                        :href="
                          getGoLink(
                            this.gamespageData.meta.geo_provider_partners_data
                              .current.go_link,
                            this.gamespageData.meta.geo_provider_partners_data
                              .current.slug
                          )
                        "
                        class="img-cas partner-logo cas-link gam-strp"
                        :rel="
                          $root.change_cta_to_sponsored
                            ? 'nofollow sponsored'
                            : 'nofollow'
                        "
                        target="_blank"
                      >
                        <img
                          class="img-over"
                          v-if="
                            $root.enable_lazyload &&
                            assets_images &&
                            assets_images.pro_asset_sizes &&
                            this.gamespageData.meta.geo_provider_partners_data
                              .current.product_assets.length > 0
                          "
                          v-lazy="
                            this.gamespageData.meta.geo_provider_partners_data.current.product_assets.filter(
                              (ele) =>
                                ele.asset_category_name ===
                                assets_images.pro_asset_sizes.medium
                            ).length > 0
                              ? this.gamespageData.meta.geo_provider_partners_data.current.product_assets
                                  .filter(
                                    (ele) =>
                                      ele.asset_category_name ===
                                      assets_images.pro_asset_sizes.medium
                                  )
                                  .shift().url
                              : ''
                          "
                          width="102"
                          height="102"
                          :alt="
                            getAltText(
                              this.gamespageData.meta.geo_provider_partners_data
                                .current.product_name,
                              this.gamespageData.meta.geo_provider_partners_data.current.product_assets.filter(
                                (ele) =>
                                  ele.asset_category_name ===
                                  assets_images.pro_asset_sizes.medium
                              ).length > 0
                                ? this.gamespageData.meta.geo_provider_partners_data.current.product_assets
                                    .filter(
                                      (ele) =>
                                        ele.asset_category_name ===
                                        assets_images.pro_asset_sizes.medium
                                    )
                                    .shift().url
                                : ''
                            )
                          "
                        />
                        <img
                          class="img-over"
                          v-else-if="
                            assets_images &&
                            assets_images.pro_asset_sizes &&
                            this.gamespageData.meta.geo_provider_partners_data
                              .current.product_assets.length > 0
                          "
                          :src="
                            this.gamespageData.meta.geo_provider_partners_data.current.product_assets.filter(
                              (ele) =>
                                ele.asset_category_name ===
                                assets_images.pro_asset_sizes.medium
                            ).length > 0
                              ? this.gamespageData.meta.geo_provider_partners_data.current.product_assets
                                  .filter(
                                    (ele) =>
                                      ele.asset_category_name ===
                                      assets_images.pro_asset_sizes.medium
                                  )
                                  .shift().url
                              : $root.site_url +
                                $root.asset_path +
                                '/failure.png'
                          "
                          width="102"
                          height="102"
                          :alt="
                            getAltText(
                              this.gamespageData.meta.geo_provider_partners_data
                                .current.product_name,
                              this.gamespageData.meta.geo_provider_partners_data.current.product_assets.filter(
                                (ele) =>
                                  ele.asset_category_name ===
                                  assets_images.pro_asset_sizes.medium
                              ).length > 0
                                ? this.gamespageData.meta.geo_provider_partners_data.current.product_assets
                                    .filter(
                                      (ele) =>
                                        ele.asset_category_name ===
                                        assets_images.pro_asset_sizes.medium
                                    )
                                    .shift().url
                                : $root.site_url +
                                    $root.asset_path +
                                    '/failure.png'
                            )
                          "
                        />
                        <div class="partner-hover wd-gam-ifrm">
                          <div
                            class="partner-hover-inner"
                            :style="{
                              '--primary-btn': $root.color_schema.primary_btn,
                              '--primary-btn-hover': pSBC(
                                -0.2,
                                $root.color_schema.primary_btn
                              ),
                            }"
                          >
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="10"
                              height="16"
                              viewBox="0 0 10 16"
                              fill="none"
                            >
                              <path
                                d="M9.44469 7.37568L2.32449 0.255608C2.15981 0.090796 1.93997 0 1.70557 0C1.47116 0 1.25133 0.090796 1.08664 0.255608L0.562291 0.779831C0.22109 1.12142 0.22109 1.6766 0.562291 2.01767L6.5413 7.99668L0.555657 13.9823C0.390975 14.1471 0.300049 14.3668 0.300049 14.6011C0.300049 14.8357 0.390975 15.0554 0.555657 15.2203L1.08001 15.7444C1.24482 15.9092 1.46453 16 1.69893 16C1.93334 16 2.15317 15.9092 2.31785 15.7444L9.44469 8.61782C9.60976 8.45248 9.70043 8.23174 9.69991 7.99707C9.70043 7.7615 9.60976 7.54088 9.44469 7.37568Z"
                                fill="white"
                              />
                            </svg>
                          </div>
                        </div>
                        <div
                          class="stripe-gam-overlay"
                          v-if="
                            Object.keys(
                              hasTag(
                                this.gamespageData.meta
                                  .geo_provider_partners_data.current.tags
                              )
                            ).length > 0
                          "
                          :style="{
                            backgroundColor:
                              Object.keys(
                                hasTag(
                                  this.gamespageData.meta
                                    .geo_provider_partners_data.current.tags
                                )
                              ).length > 0
                                ? hasTag(
                                    this.gamespageData.meta
                                      .geo_provider_partners_data.current.tags
                                  ).color
                                : null,
                          }"
                        >
                          <span
                            :class="{
                              'custom-font-2': true,
                              'text-gray': getContrastYIQ(
                                Object.keys(
                                  hasTag(
                                    this.gamespageData.meta
                                      .geo_provider_partners_data.current.tags
                                  )
                                ).length > 0
                                  ? hasTag(
                                      this.gamespageData.meta
                                        .geo_provider_partners_data.current.tags
                                    ).color
                                  : null
                              ),
                              'text-light': !getContrastYIQ(
                                Object.keys(
                                  hasTag(
                                    this.gamespageData.meta
                                      .geo_provider_partners_data.current.tags
                                  )
                                ).length > 0
                                  ? hasTag(
                                      this.gamespageData.meta
                                        .geo_provider_partners_data.current.tags
                                    ).color
                                  : null
                              ),
                            }"
                          >
                            <img
                              :src="
                                hasTag(
                                  this.gamespageData.meta
                                    .geo_provider_partners_data.current.tags
                                ).icon
                              "
                              width="18"
                              height="12"
                              alt="tag-icons"
                            />
                            {{
                              titleCase(
                                hasTag(
                                  this.gamespageData.meta
                                    .geo_provider_partners_data.current.tags
                                ).tag_name
                              )
                            }}
                          </span>
                        </div>
                      </a>
                    </template>
                    <div
                      class="best-rating"
                      v-if="
                        this.gamespageData.meta.geo_provider_partners_data &&
                        this.gamespageData.meta.geo_provider_partners_data
                          .current &&
                        this.gamespageData.meta.geo_provider_partners_data &&
                        this.gamespageData.meta.geo_provider_partners_data
                          .current.rating
                      "
                    >
                      <StarRating
                        :rating="
                          parseFloat(
                            (
                              this.gamespageData.meta
                                .geo_provider_partners_data &&
                              this.gamespageData.meta.geo_provider_partners_data
                                .current.rating / 2
                            ).toFixed(1)
                          )
                        "
                        noText
                      />
                    </div>
                    <span class="how-about"
                      >{{ $root.i18n.how_about_a_special_offer_from }}
                      {{
                        this.gamespageData.meta.geo_provider_partners_data &&
                        this.gamespageData.meta.geo_provider_partners_data
                          .current &&
                        this.gamespageData.meta.geo_provider_partners_data &&
                        this.gamespageData.meta.geo_provider_partners_data
                          .current &&
                        this.gamespageData.meta.geo_provider_partners_data &&
                        this.gamespageData.meta.geo_provider_partners_data
                          .current &&
                        this.gamespageData.meta.geo_provider_partners_data &&
                        this.gamespageData.meta.geo_provider_partners_data
                          .current
                          ? this.gamespageData.meta
                              .geo_provider_partners_data &&
                            this.gamespageData.meta.geo_provider_partners_data
                              .current &&
                            this.gamespageData.meta
                              .geo_provider_partners_data &&
                            this.gamespageData.meta.geo_provider_partners_data
                              .current.product_name
                          : ""
                      }}
                      ?</span
                    >
                    <template v-if="hideToplistLabelGB"> </template>
                    <template v-else>
                      <a
                        v-if="
                          this.gamespageData.meta.geo_provider_partners_data &&
                          this.gamespageData.meta.geo_provider_partners_data
                            .current &&
                          this.gamespageData.meta.geo_provider_partners_data
                            .current.go_link
                        "
                        :title="
                          this.gamespageData.meta.geo_provider_partners_data
                            .current.product_name
                        "
                        :href="
                          getGoLink(
                            this.gamespageData.meta.geo_provider_partners_data
                              .current.go_link,
                            this.gamespageData.meta.geo_provider_partners_data
                              .current.slug
                          )
                        "
                        class="get-a cas-link"
                        :rel="
                          $root.change_cta_to_sponsored
                            ? 'nofollow sponsored'
                            : 'nofollow'
                        "
                        target="_blank"
                        >{{ $root.i18n.get_best_bonus_for_this_game }}!!</a
                      >
                    </template>
                    <div class="text-wrapper">
                      <template v-if="hideToplistLabelGB"> </template>
                      <template v-else>
                        <a
                          v-if="
                            this.gamespageData.meta
                              .geo_provider_partners_data &&
                            this.gamespageData.meta.geo_provider_partners_data
                              .current &&
                            this.gamespageData.meta.geo_provider_partners_data
                              .current.go_link
                          "
                          :title="
                            this.gamespageData.meta.geo_provider_partners_data
                              .current.product_name
                          "
                          :href="
                            getGoLink(
                              this.gamespageData.meta.geo_provider_partners_data
                                .current.go_link,
                              this.gamespageData.meta.geo_provider_partners_data
                                .current.slug
                            )
                          "
                          :class="{
                            'cta cta-block cta-primary cta-promotion custom-btn cas-link hover-btn ct-btn': true,
                            'text-white':
                              !$root.override_ctabtntxt_color &&
                              !getContrastYIQ($root.color_schema.primary_btn),
                            'text-gray':
                              !$root.override_ctabtntxt_color &&
                              getContrastYIQ($root.color_schema.primary_btn),
                            'text-cta-override': $root.override_ctabtntxt_color,
                          }"
                          :rel="
                            $root.change_cta_to_sponsored
                              ? 'nofollow sponsored'
                              : 'nofollow'
                          "
                          target="_blank"
                          :style="{
                            '--primary-btn': $root.color_schema.primary_btn,
                            '--primary-btn-hover': pSBC(
                              -0.2,
                              $root.color_schema.primary_btn
                            ),
                          }"
                          ><span class="cta-text">{{
                            $root.i18n.get_bonus
                          }}</span
                          ><span
                            class="hover-text"
                            v-for="(char, indexGo) in $root.i18n.go_to_casino"
                            :key="indexGo + `gambsppp`"
                            >{{ char }}</span
                          >
                          <!--<span
                        class="hover-text"
                        v-for="(char,
                        indexPro) in this.gamespageData.meta.geo_provider_partners_data.current.product_name.split(
                          ''
                        )"
                        :key="indexPro + `gambsp`"
                        >{{ char }}</span
                      >--></a
                        >
                      </template>
                      <span
                        class="
                          cta cta-secondary cta-promotion cta-lg-br
                          back-btn
                          ct-btn
                        "
                        @click="overlayHide()"
                        >{{ $root.i18n.no_thanks }}</span
                      >
                    </div>
                  </div>
                </fullscreen>
              </template>
              <template v-else>
                <template
                  v-if="
                    widthofgamesection < 576 &&
                    this.gamespageData.meta &&
                    this.gamespageData.meta.mobile_game_iframe_url &&
                    this.gamespageData.meta.mobile_game_iframe_url != ''
                  "
                >
                  <div
                    :class="{
                      'wrapper-iframe': true,
                      'wrapper-game-iframe':
                        this.gameTemplate &&
                        gamesTop3 &&
                        gamesTop3.length > 0 &&
                        gamesTop3[0] &&
                        gamesTop3[0].length > 0,
                    }"
                    id="wrapper-iframe"
                  >
                    <iframe
                      class="cas-iframe"
                      id="cas-iframe"
                      :src="this.gamespageData.meta.mobile_game_iframe_url"
                      @load="openFullscreen()"
                    ></iframe>
                  </div>
                  <div
                    v-if="
                      !$root.disable_freegame_banner_outlink &&
                      gameOverlay &&
                      this.gamespageData.meta.geo_provider_partners_data &&
                      this.gamespageData.meta.geo_provider_partners_data.current
                    "
                    class="cta-overlay cta-overlay-enable-mobile"
                    :style="{
                      'background-color': color,
                      '--primary-color': getContrastYIQ('#060236')
                        ? '#333'
                        : '#fff',
                    }"
                  >
                    <template v-if="hideToplistLabelGB"> </template>
                    <template v-else>
                      <a
                        v-if="
                          this.gamespageData.meta.geo_provider_partners_data &&
                          this.gamespageData.meta.geo_provider_partners_data
                            .current &&
                          this.gamespageData.meta.geo_provider_partners_data
                            .current.go_link
                        "
                        :title="
                          this.gamespageData.meta.geo_provider_partners_data
                            .current.product_name
                        "
                        :href="
                          getGoLink(
                            this.gamespageData.meta.geo_provider_partners_data
                              .current.go_link,
                            this.gamespageData.meta.geo_provider_partners_data
                              .current.slug
                          )
                        "
                        class="img-cas partner-logo cas-link gam-strp"
                        :rel="
                          $root.change_cta_to_sponsored
                            ? 'nofollow sponsored'
                            : 'nofollow'
                        "
                        target="_blank"
                      >
                        <img
                          class="img-over"
                          v-if="
                            $root.enable_lazyload &&
                            assets_images &&
                            assets_images.pro_asset_sizes &&
                            this.gamespageData.meta.geo_provider_partners_data
                              .current.product_assets.length > 0
                          "
                          v-lazy="
                            this.gamespageData.meta.geo_provider_partners_data.current.product_assets.filter(
                              (ele) =>
                                ele.asset_category_name ===
                                assets_images.pro_asset_sizes.medium
                            ).length > 0
                              ? this.gamespageData.meta.geo_provider_partners_data.current.product_assets
                                  .filter(
                                    (ele) =>
                                      ele.asset_category_name ===
                                      assets_images.pro_asset_sizes.medium
                                  )
                                  .shift().url
                              : ''
                          "
                          width="102"
                          height="102"
                          :alt="
                            getAltText(
                              this.gamespageData.meta.geo_provider_partners_data
                                .current.product_name,
                              this.gamespageData.meta.geo_provider_partners_data.current.product_assets.filter(
                                (ele) =>
                                  ele.asset_category_name ===
                                  assets_images.pro_asset_sizes.medium
                              ).length > 0
                                ? this.gamespageData.meta.geo_provider_partners_data.current.product_assets
                                    .filter(
                                      (ele) =>
                                        ele.asset_category_name ===
                                        assets_images.pro_asset_sizes.medium
                                    )
                                    .shift().url
                                : ''
                            )
                          "
                        />
                        <img
                          class="img-over"
                          v-else-if="
                            assets_images &&
                            assets_images.pro_asset_sizes &&
                            this.gamespageData.meta.geo_provider_partners_data
                              .current.product_assets.length > 0
                          "
                          :src="
                            this.gamespageData.meta.geo_provider_partners_data.current.product_assets.filter(
                              (ele) =>
                                ele.asset_category_name ===
                                assets_images.pro_asset_sizes.medium
                            ).length > 0
                              ? this.gamespageData.meta.geo_provider_partners_data.current.product_assets
                                  .filter(
                                    (ele) =>
                                      ele.asset_category_name ===
                                      assets_images.pro_asset_sizes.medium
                                  )
                                  .shift().url
                              : $root.site_url +
                                $root.asset_path +
                                '/failure.png'
                          "
                          width="102"
                          height="102"
                          :alt="
                            getAltText(
                              this.gamespageData.meta.geo_provider_partners_data
                                .current.product_name,
                              this.gamespageData.meta.geo_provider_partners_data.current.product_assets.filter(
                                (ele) =>
                                  ele.asset_category_name ===
                                  assets_images.pro_asset_sizes.medium
                              ).length > 0
                                ? this.gamespageData.meta.geo_provider_partners_data.current.product_assets
                                    .filter(
                                      (ele) =>
                                        ele.asset_category_name ===
                                        assets_images.pro_asset_sizes.medium
                                    )
                                    .shift().url
                                : $root.site_url +
                                    $root.asset_path +
                                    '/failure.png'
                            )
                          "
                        />
                        <div class="partner-hover wd-gam-ifrm">
                          <div
                            class="partner-hover-inner"
                            :style="{
                              '--primary-btn': $root.color_schema.primary_btn,
                              '--primary-btn-hover': pSBC(
                                -0.2,
                                $root.color_schema.primary_btn
                              ),
                            }"
                          >
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="10"
                              height="16"
                              viewBox="0 0 10 16"
                              fill="none"
                            >
                              <path
                                d="M9.44469 7.37568L2.32449 0.255608C2.15981 0.090796 1.93997 0 1.70557 0C1.47116 0 1.25133 0.090796 1.08664 0.255608L0.562291 0.779831C0.22109 1.12142 0.22109 1.6766 0.562291 2.01767L6.5413 7.99668L0.555657 13.9823C0.390975 14.1471 0.300049 14.3668 0.300049 14.6011C0.300049 14.8357 0.390975 15.0554 0.555657 15.2203L1.08001 15.7444C1.24482 15.9092 1.46453 16 1.69893 16C1.93334 16 2.15317 15.9092 2.31785 15.7444L9.44469 8.61782C9.60976 8.45248 9.70043 8.23174 9.69991 7.99707C9.70043 7.7615 9.60976 7.54088 9.44469 7.37568Z"
                                fill="white"
                              />
                            </svg>
                          </div>
                        </div>
                        <div
                          class="stripe-gam-overlay"
                          v-if="
                            Object.keys(
                              hasTag(
                                this.gamespageData.meta
                                  .geo_provider_partners_data.current.tags
                              )
                            ).length > 0
                          "
                          :style="{
                            backgroundColor:
                              Object.keys(
                                hasTag(
                                  this.gamespageData.meta
                                    .geo_provider_partners_data.current.tags
                                )
                              ).length > 0
                                ? hasTag(
                                    this.gamespageData.meta
                                      .geo_provider_partners_data.current.tags
                                  ).color
                                : null,
                          }"
                        >
                          <span
                            :class="{
                              'custom-font-2': true,
                              'text-gray': getContrastYIQ(
                                Object.keys(
                                  hasTag(
                                    this.gamespageData.meta
                                      .geo_provider_partners_data.current.tags
                                  )
                                ).length > 0
                                  ? hasTag(
                                      this.gamespageData.meta
                                        .geo_provider_partners_data.current.tags
                                    ).color
                                  : null
                              ),
                              'text-light': !getContrastYIQ(
                                Object.keys(
                                  hasTag(
                                    this.gamespageData.meta
                                      .geo_provider_partners_data.current.tags
                                  )
                                ).length > 0
                                  ? hasTag(
                                      this.gamespageData.meta
                                        .geo_provider_partners_data.current.tags
                                    ).color
                                  : null
                              ),
                            }"
                          >
                            <img
                              :src="
                                hasTag(
                                  this.gamespageData.meta
                                    .geo_provider_partners_data.current.tags
                                ).icon
                              "
                              width="18"
                              height="12"
                              alt="tag-icons"
                            />
                            {{
                              titleCase(
                                hasTag(
                                  this.gamespageData.meta
                                    .geo_provider_partners_data.current.tags
                                ).tag_name
                              )
                            }}
                          </span>
                        </div>
                      </a>
                    </template>
                    <div
                      class="best-rating"
                      v-if="
                        this.gamespageData.meta.geo_provider_partners_data &&
                        this.gamespageData.meta.geo_provider_partners_data
                          .current &&
                        this.gamespageData.meta.geo_provider_partners_data &&
                        this.gamespageData.meta.geo_provider_partners_data
                          .current.rating
                      "
                    >
                      <StarRating
                        :rating="
                          parseFloat(
                            (
                              this.gamespageData.meta
                                .geo_provider_partners_data &&
                              this.gamespageData.meta.geo_provider_partners_data
                                .current.rating / 2
                            ).toFixed(1)
                          )
                        "
                        noText
                      />
                    </div>
                    <span class="how-about"
                      >{{ $root.i18n.how_about_a_special_offer_from }}
                      {{
                        this.gamespageData.meta.geo_provider_partners_data &&
                        this.gamespageData.meta.geo_provider_partners_data
                          .current &&
                        this.gamespageData.meta.geo_provider_partners_data &&
                        this.gamespageData.meta.geo_provider_partners_data
                          .current &&
                        this.gamespageData.meta.geo_provider_partners_data &&
                        this.gamespageData.meta.geo_provider_partners_data
                          .current &&
                        this.gamespageData.meta.geo_provider_partners_data &&
                        this.gamespageData.meta.geo_provider_partners_data
                          .current
                          ? this.gamespageData.meta
                              .geo_provider_partners_data &&
                            this.gamespageData.meta.geo_provider_partners_data
                              .current &&
                            this.gamespageData.meta
                              .geo_provider_partners_data &&
                            this.gamespageData.meta.geo_provider_partners_data
                              .current.product_name
                          : ""
                      }}
                      ?</span
                    >
                    <template v-if="hideToplistLabelGB"> </template>
                    <template v-else>
                      <a
                        v-if="
                          this.gamespageData.meta.geo_provider_partners_data &&
                          this.gamespageData.meta.geo_provider_partners_data
                            .current &&
                          this.gamespageData.meta.geo_provider_partners_data
                            .current.go_link
                        "
                        :title="
                          this.gamespageData.meta.geo_provider_partners_data
                            .current.product_name
                        "
                        :href="
                          getGoLink(
                            this.gamespageData.meta.geo_provider_partners_data
                              .current.go_link,
                            this.gamespageData.meta.geo_provider_partners_data
                              .current.slug
                          )
                        "
                        class="get-a cas-link"
                        :rel="
                          $root.change_cta_to_sponsored
                            ? 'nofollow sponsored'
                            : 'nofollow'
                        "
                        target="_blank"
                        >{{ $root.i18n.get_best_bonus_for_this_game }}!!</a
                      >
                    </template>
                    <div class="text-wrapper">
                      <template v-if="hideToplistLabelGB"> </template>
                      <template v-else>
                        <a
                          v-if="
                            this.gamespageData.meta
                              .geo_provider_partners_data &&
                            this.gamespageData.meta.geo_provider_partners_data
                              .current &&
                            this.gamespageData.meta.geo_provider_partners_data
                              .current.go_link
                          "
                          :title="
                            this.gamespageData.meta.geo_provider_partners_data
                              .current.product_name
                          "
                          :href="
                            getGoLink(
                              this.gamespageData.meta.geo_provider_partners_data
                                .current.go_link,
                              this.gamespageData.meta.geo_provider_partners_data
                                .current.slug
                            )
                          "
                          :class="{
                            'cta cta-block cta-primary cta-promotion custom-btn cas-link hover-btn ct-btn': true,
                            'text-white':
                              !$root.override_ctabtntxt_color &&
                              !getContrastYIQ($root.color_schema.primary_btn),
                            'text-gray':
                              !$root.override_ctabtntxt_color &&
                              getContrastYIQ($root.color_schema.primary_btn),
                            'text-cta-override': $root.override_ctabtntxt_color,
                          }"
                          :rel="
                            $root.change_cta_to_sponsored
                              ? 'nofollow sponsored'
                              : 'nofollow'
                          "
                          target="_blank"
                          :style="{
                            '--primary-btn': $root.color_schema.primary_btn,
                            '--primary-btn-hover': pSBC(
                              -0.2,
                              $root.color_schema.primary_btn
                            ),
                          }"
                          ><span class="cta-text">{{
                            $root.i18n.get_bonus
                          }}</span
                          ><span
                            class="hover-text"
                            v-for="(char, indexGo) in $root.i18n.go_to_casino"
                            :key="indexGo + `gambsppp`"
                            >{{ char }}</span
                          >
                          <!--<span
                        class="hover-text"
                        v-for="(char,
                        indexPro) in this.gamespageData.meta.geo_provider_partners_data.current.product_name.split(
                          ''
                        )"
                        :key="indexPro + `gambsp`"
                        >{{ char }}</span
                      >--></a
                        >
                      </template>
                      <span
                        class="
                          cta cta-secondary cta-promotion cta-lg-br
                          back-btn
                          ct-btn
                        "
                        @click="overlayHide()"
                        >{{ $root.i18n.no_thanks }}</span
                      >
                    </div>
                  </div>
                </template>
                <template v-else>
                  <div
                    :class="{
                      'wrapper-iframe': true,
                      'wrapper-game-iframe':
                        this.gameTemplate &&
                        gamesTop3 &&
                        gamesTop3.length > 0 &&
                        gamesTop3[0] &&
                        gamesTop3[0].length > 0,
                    }"
                    id="wrapper-iframe"
                  >
                    <iframe
                      class="cas-iframe"
                      id="cas-iframe"
                      :src="this.gamespageData.meta.play_for_free_url"
                      @load="openFullscreen()"
                    ></iframe>
                  </div>
                  <div
                    v-if="
                      !$root.disable_freegame_banner_outlink &&
                      gameOverlay &&
                      this.gamespageData.meta.geo_provider_partners_data &&
                      this.gamespageData.meta.geo_provider_partners_data.current
                    "
                    class="cta-overlay"
                    :style="{
                      'background-color': color,
                      '--primary-color': getContrastYIQ('#060236')
                        ? '#333'
                        : '#fff',
                    }"
                  >
                    <template v-if="hideToplistLabelGB"> </template>
                    <template v-else>
                      <a
                        v-if="
                          this.gamespageData.meta.geo_provider_partners_data &&
                          this.gamespageData.meta.geo_provider_partners_data
                            .current &&
                          this.gamespageData.meta.geo_provider_partners_data
                            .current.go_link
                        "
                        :title="
                          this.gamespageData.meta.geo_provider_partners_data
                            .current.product_name
                        "
                        :href="
                          getGoLink(
                            this.gamespageData.meta.geo_provider_partners_data
                              .current.go_link,
                            this.gamespageData.meta.geo_provider_partners_data
                              .current.slug
                          )
                        "
                        class="img-cas partner-logo cas-link gam-strp"
                        :rel="
                          $root.change_cta_to_sponsored
                            ? 'nofollow sponsored'
                            : 'nofollow'
                        "
                        target="_blank"
                      >
                        <img
                          class="img-over"
                          v-if="
                            $root.enable_lazyload &&
                            assets_images &&
                            assets_images.pro_asset_sizes &&
                            this.gamespageData.meta.geo_provider_partners_data
                              .current.product_assets.length > 0
                          "
                          v-lazy="
                            this.gamespageData.meta.geo_provider_partners_data.current.product_assets.filter(
                              (ele) =>
                                ele.asset_category_name ===
                                assets_images.pro_asset_sizes.medium
                            ).length > 0
                              ? this.gamespageData.meta.geo_provider_partners_data.current.product_assets
                                  .filter(
                                    (ele) =>
                                      ele.asset_category_name ===
                                      assets_images.pro_asset_sizes.medium
                                  )
                                  .shift().url
                              : ''
                          "
                          width="102"
                          height="102"
                          :alt="
                            getAltText(
                              this.gamespageData.meta.geo_provider_partners_data
                                .current.product_name,
                              this.gamespageData.meta.geo_provider_partners_data.current.product_assets.filter(
                                (ele) =>
                                  ele.asset_category_name ===
                                  assets_images.pro_asset_sizes.medium
                              ).length > 0
                                ? this.gamespageData.meta.geo_provider_partners_data.current.product_assets
                                    .filter(
                                      (ele) =>
                                        ele.asset_category_name ===
                                        assets_images.pro_asset_sizes.medium
                                    )
                                    .shift().url
                                : ''
                            )
                          "
                        />
                        <img
                          class="img-over"
                          v-else-if="
                            assets_images &&
                            assets_images.pro_asset_sizes &&
                            this.gamespageData.meta.geo_provider_partners_data
                              .current.product_assets.length > 0
                          "
                          :src="
                            this.gamespageData.meta.geo_provider_partners_data.current.product_assets.filter(
                              (ele) =>
                                ele.asset_category_name ===
                                assets_images.pro_asset_sizes.medium
                            ).length > 0
                              ? this.gamespageData.meta.geo_provider_partners_data.current.product_assets
                                  .filter(
                                    (ele) =>
                                      ele.asset_category_name ===
                                      assets_images.pro_asset_sizes.medium
                                  )
                                  .shift().url
                              : $root.site_url +
                                $root.asset_path +
                                '/failure.png'
                          "
                          width="102"
                          height="102"
                          :alt="
                            getAltText(
                              this.gamespageData.meta.geo_provider_partners_data
                                .current.product_name,
                              this.gamespageData.meta.geo_provider_partners_data.current.product_assets.filter(
                                (ele) =>
                                  ele.asset_category_name ===
                                  assets_images.pro_asset_sizes.medium
                              ).length > 0
                                ? this.gamespageData.meta.geo_provider_partners_data.current.product_assets
                                    .filter(
                                      (ele) =>
                                        ele.asset_category_name ===
                                        assets_images.pro_asset_sizes.medium
                                    )
                                    .shift().url
                                : $root.site_url +
                                    $root.asset_path +
                                    '/failure.png'
                            )
                          "
                        />
                        <div class="partner-hover wd-gam-ifrm">
                          <div
                            class="partner-hover-inner"
                            :style="{
                              '--primary-btn': $root.color_schema.primary_btn,
                              '--primary-btn-hover': pSBC(
                                -0.2,
                                $root.color_schema.primary_btn
                              ),
                            }"
                          >
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="10"
                              height="16"
                              viewBox="0 0 10 16"
                              fill="none"
                            >
                              <path
                                d="M9.44469 7.37568L2.32449 0.255608C2.15981 0.090796 1.93997 0 1.70557 0C1.47116 0 1.25133 0.090796 1.08664 0.255608L0.562291 0.779831C0.22109 1.12142 0.22109 1.6766 0.562291 2.01767L6.5413 7.99668L0.555657 13.9823C0.390975 14.1471 0.300049 14.3668 0.300049 14.6011C0.300049 14.8357 0.390975 15.0554 0.555657 15.2203L1.08001 15.7444C1.24482 15.9092 1.46453 16 1.69893 16C1.93334 16 2.15317 15.9092 2.31785 15.7444L9.44469 8.61782C9.60976 8.45248 9.70043 8.23174 9.69991 7.99707C9.70043 7.7615 9.60976 7.54088 9.44469 7.37568Z"
                                fill="white"
                              />
                            </svg>
                          </div>
                        </div>
                        <div
                          class="stripe-gam-overlay"
                          v-if="
                            Object.keys(
                              hasTag(
                                this.gamespageData.meta
                                  .geo_provider_partners_data.current.tags
                              )
                            ).length > 0
                          "
                          :style="{
                            backgroundColor:
                              Object.keys(
                                hasTag(
                                  this.gamespageData.meta
                                    .geo_provider_partners_data.current.tags
                                )
                              ).length > 0
                                ? hasTag(
                                    this.gamespageData.meta
                                      .geo_provider_partners_data.current.tags
                                  ).color
                                : null,
                          }"
                        >
                          <span
                            :class="{
                              'custom-font-2': true,
                              'text-gray': getContrastYIQ(
                                Object.keys(
                                  hasTag(
                                    this.gamespageData.meta
                                      .geo_provider_partners_data.current.tags
                                  )
                                ).length > 0
                                  ? hasTag(
                                      this.gamespageData.meta
                                        .geo_provider_partners_data.current.tags
                                    ).color
                                  : null
                              ),
                              'text-light': !getContrastYIQ(
                                Object.keys(
                                  hasTag(
                                    this.gamespageData.meta
                                      .geo_provider_partners_data.current.tags
                                  )
                                ).length > 0
                                  ? hasTag(
                                      this.gamespageData.meta
                                        .geo_provider_partners_data.current.tags
                                    ).color
                                  : null
                              ),
                            }"
                          >
                            <img
                              :src="
                                hasTag(
                                  this.gamespageData.meta
                                    .geo_provider_partners_data.current.tags
                                ).icon
                              "
                              width="18"
                              height="12"
                              alt="tag-icons"
                            />
                            {{
                              titleCase(
                                hasTag(
                                  this.gamespageData.meta
                                    .geo_provider_partners_data.current.tags
                                ).tag_name
                              )
                            }}
                          </span>
                        </div>
                      </a>
                    </template>
                    <div
                      class="best-rating"
                      v-if="
                        this.gamespageData.meta.geo_provider_partners_data &&
                        this.gamespageData.meta.geo_provider_partners_data
                          .current &&
                        this.gamespageData.meta.geo_provider_partners_data &&
                        this.gamespageData.meta.geo_provider_partners_data
                          .current.rating
                      "
                    >
                      <StarRating
                        :rating="
                          parseFloat(
                            (
                              this.gamespageData.meta
                                .geo_provider_partners_data &&
                              this.gamespageData.meta.geo_provider_partners_data
                                .current.rating / 2
                            ).toFixed(1)
                          )
                        "
                        noText
                      />
                    </div>
                    <span class="how-about"
                      >{{ $root.i18n.how_about_a_special_offer_from }}
                      {{
                        this.gamespageData.meta.geo_provider_partners_data &&
                        this.gamespageData.meta.geo_provider_partners_data
                          .current &&
                        this.gamespageData.meta.geo_provider_partners_data &&
                        this.gamespageData.meta.geo_provider_partners_data
                          .current &&
                        this.gamespageData.meta.geo_provider_partners_data &&
                        this.gamespageData.meta.geo_provider_partners_data
                          .current &&
                        this.gamespageData.meta.geo_provider_partners_data &&
                        this.gamespageData.meta.geo_provider_partners_data
                          .current
                          ? this.gamespageData.meta
                              .geo_provider_partners_data &&
                            this.gamespageData.meta.geo_provider_partners_data
                              .current &&
                            this.gamespageData.meta
                              .geo_provider_partners_data &&
                            this.gamespageData.meta.geo_provider_partners_data
                              .current.product_name
                          : ""
                      }}
                      ?</span
                    >
                    <template v-if="hideToplistLabelGB"> </template>
                    <template v-else>
                      <a
                        v-if="
                          this.gamespageData.meta.geo_provider_partners_data &&
                          this.gamespageData.meta.geo_provider_partners_data
                            .current &&
                          this.gamespageData.meta.geo_provider_partners_data
                            .current.go_link
                        "
                        :title="
                          this.gamespageData.meta.geo_provider_partners_data
                            .current.product_name
                        "
                        :href="
                          getGoLink(
                            this.gamespageData.meta.geo_provider_partners_data
                              .current.go_link,
                            this.gamespageData.meta.geo_provider_partners_data
                              .current.slug
                          )
                        "
                        class="get-a cas-link"
                        :rel="
                          $root.change_cta_to_sponsored
                            ? 'nofollow sponsored'
                            : 'nofollow'
                        "
                        target="_blank"
                        >{{ $root.i18n.get_best_bonus_for_this_game }}!!</a
                      >
                    </template>
                    <div class="text-wrapper">
                      <template v-if="hideToplistLabelGB"> </template>
                      <template v-else>
                        <a
                          v-if="
                            this.gamespageData.meta
                              .geo_provider_partners_data &&
                            this.gamespageData.meta.geo_provider_partners_data
                              .current &&
                            this.gamespageData.meta.geo_provider_partners_data
                              .current.go_link
                          "
                          :title="
                            this.gamespageData.meta.geo_provider_partners_data
                              .current.product_name
                          "
                          :href="
                            getGoLink(
                              this.gamespageData.meta.geo_provider_partners_data
                                .current.go_link,
                              this.gamespageData.meta.geo_provider_partners_data
                                .current.slug
                            )
                          "
                          :class="{
                            'cta cta-block cta-primary cta-promotion custom-btn cas-link hover-btn ct-btn': true,
                            'text-white':
                              !$root.override_ctabtntxt_color &&
                              !getContrastYIQ($root.color_schema.primary_btn),
                            'text-gray':
                              !$root.override_ctabtntxt_color &&
                              getContrastYIQ($root.color_schema.primary_btn),
                            'text-cta-override': $root.override_ctabtntxt_color,
                          }"
                          :rel="
                            $root.change_cta_to_sponsored
                              ? 'nofollow sponsored'
                              : 'nofollow'
                          "
                          target="_blank"
                          :style="{
                            '--primary-btn': $root.color_schema.primary_btn,
                            '--primary-btn-hover': pSBC(
                              -0.2,
                              $root.color_schema.primary_btn
                            ),
                          }"
                          ><span class="cta-text">{{
                            $root.i18n.get_bonus
                          }}</span
                          ><span
                            class="hover-text"
                            v-for="(char, indexGo) in $root.i18n.go_to_casino"
                            :key="indexGo + `gambsppp`"
                            >{{ char }}</span
                          >
                          <!--<span
                        class="hover-text"
                        v-for="(char,
                        indexPro) in this.gamespageData.meta.geo_provider_partners_data.current.product_name.split(
                          ''
                        )"
                        :key="indexPro + `gambsp`"
                        >{{ char }}</span
                      >--></a
                        >
                      </template>
                      <span
                        class="
                          cta cta-secondary cta-promotion cta-lg-br
                          back-btn
                          ct-btn
                        "
                        @click="overlayHide()"
                        >{{ $root.i18n.no_thanks }}</span
                      >
                    </div>
                  </div>
                </template>
              </template>
            </div>
          </div>
          <div
            :class="{
              'col-md-4': !this.gameTemplate,
              'game-right':
                this.gameTemplate &&
                gamesTop3 &&
                gamesTop3.length > 0 &&
                gamesTop3[0] &&
                gamesTop3[0].length > 0,
              'ct-inner-banner-rgt':
                (this.gameTemplate &&
                  gamesTop3 &&
                  gamesTop3.length > 0 &&
                  gamesTop3[0] &&
                  gamesTop3[0].length > 0) ||
                !this.gameTemplate,
            }"
          >
            <!--mob-game-title -->
            <template v-if="this.gameTemplate">
              <template v-if="gamesTop3.length > 0">
                <div v-for="(val, index) in gamesTop3" :key="index">
                  <!-- <span
                    v-if="val && val.length > 0"
                    :class="{
                      'span-h1 custom-font-1 cust-h1 ': true,
                      'font-light': !getContrastYIQ(
                        $root.color_schema.footer_bg
                      ),
                    }"
                    >{{ gamesTop3Title[index] }}</span
                  > -->
                  <component 
                    :is="titleComponent"
                    :class="{
                        'text-white gm-title': true, 
                        'cust-h1': titleComponent === 'span'   
                    }"
                    >
                    {{ gamesTop3Title[index] }}
                  </component>
                  <div class="mobile-scroller">
                    <div
                      v-for="(data, index) in val"
                      :key="index"
                      class="play-card"
                      :style="{
                        'border': index === 0 ? `2px solid #ffd03a` : null,
                        'background-color': index === 0 ? '#FFF9E8' : null,
                        'overflow': 'hidden'
                      }"
                    >
                      <!-- <div class="top-choice-medal" v-if="index === 0">
                        <img
                          :src="
                            $root.site_url + $root.asset_path + '/medal-1.svg'
                          "
                          width="31"
                          height="35"
                          alt="medel"
                        />
                      </div> -->
                      <div :class="`play-card-index play-card-index-${index}`">{{index + 1}}</div>
                      <div class="play-card-top">
                        <div class="play-card-top-img">
                          <a
                            :title="data.product_name"
                            :href="getGoLink(data.go_link, data.slug)"
                            class="partner-logo cas-link"
                            :rel="
                              $root.change_cta_to_sponsored
                                ? 'nofollow sponsored'
                                : 'nofollow'
                            "
                            target="_blank"
                          >
                            <img
                              v-if="
                                $root.enable_lazyload &&
                                assets_images &&
                                assets_images.pro_asset_sizes
                              "
                              v-lazy="
                                data.product_assets.filter(
                                  (ele) =>
                                    ele.asset_category_name ===
                                    assets_images.pro_asset_sizes.medium
                                ).length > 0
                                  ? data.product_assets.filter(
                                      (ele) =>
                                        ele.asset_category_name ===
                                        assets_images.pro_asset_sizes.medium
                                    )[0].url
                                  : ''
                              "
                              width="40"
                              height="40"
                              :alt="
                                getAltText(
                                  data.product_name,
                                  data.product_assets.filter(
                                    (ele) =>
                                      ele.asset_category_name ===
                                      assets_images.pro_asset_sizes.medium
                                  ).length > 0
                                    ? data.product_assets.filter(
                                        (ele) =>
                                          ele.asset_category_name ===
                                          assets_images.pro_asset_sizes.medium
                                      )[0].url
                                    : ''
                                )
                              "
                            />
                            <img
                              v-else-if="
                                assets_images && assets_images.pro_asset_sizes
                              "
                              :src="
                                data.product_assets.filter(
                                  (ele) =>
                                    ele.asset_category_name ===
                                    assets_images.pro_asset_sizes.medium
                                ).length > 0
                                  ? data.product_assets.filter(
                                      (ele) =>
                                        ele.asset_category_name ===
                                        assets_images.pro_asset_sizes.medium
                                    )[0].url
                                  : $root.site_url +
                                    $root.asset_path +
                                    '/failure.png'
                              "
                              width="40"
                              height="40"
                              :alt="
                                getAltText(
                                  data.product_name,
                                  data.product_assets.filter(
                                    (ele) =>
                                      ele.asset_category_name ===
                                      assets_images.pro_asset_sizes.medium
                                  ).length > 0
                                    ? data.product_assets.filter(
                                        (ele) =>
                                          ele.asset_category_name ===
                                          assets_images.pro_asset_sizes.medium
                                      )[0].url
                                    : $root.site_url +
                                        $root.asset_path +
                                        '/failure.png'
                                )
                              "
                            />
                            <div class="partner-hover wd-gam-cas">
                              <div
                                class="partner-hover-inner"
                                :style="{
                                  '--primary-btn':
                                    $root.color_schema.primary_btn,
                                  '--primary-btn-hover': pSBC(
                                    -0.2,
                                    $root.color_schema.primary_btn
                                  ),
                                }"
                              >
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="10"
                                  height="16"
                                  viewBox="0 0 10 16"
                                  fill="none"
                                >
                                  <path
                                    d="M9.44469 7.37568L2.32449 0.255608C2.15981 0.090796 1.93997 0 1.70557 0C1.47116 0 1.25133 0.090796 1.08664 0.255608L0.562291 0.779831C0.22109 1.12142 0.22109 1.6766 0.562291 2.01767L6.5413 7.99668L0.555657 13.9823C0.390975 14.1471 0.300049 14.3668 0.300049 14.6011C0.300049 14.8357 0.390975 15.0554 0.555657 15.2203L1.08001 15.7444C1.24482 15.9092 1.46453 16 1.69893 16C1.93334 16 2.15317 15.9092 2.31785 15.7444L9.44469 8.61782C9.60976 8.45248 9.70043 8.23174 9.69991 7.99707C9.70043 7.7615 9.60976 7.54088 9.44469 7.37568Z"
                                    fill="white"
                                  />
                                </svg>
                              </div>
                            </div>
                            <!-- <div
                              :class="{
                                stripe: hasTag(data.tags),
                                'stripe-text text-center': true,
                                'font-dark': getContrastYIQ(
                                  $root.color_schema.tag_bg
                                ),
                                'font-light': !getContrastYIQ(
                                  $root.color_schema.tag_bg
                                ),
                              }"
                              v-if="index != 0 && data.tags"
                              :style="{
                                backgroundColor:
                                  hasTag(data.tags) != ''
                                    ? $root.color_schema.tag_bg
                                    : 'none',
                              }"
                            >
                              {{ hasTag(data.tags) }}
                            </div>-->
                          </a>
                        </div>
                        <div class="play-card-top-right">
                          <template v-if="$root.enable_piwik_reload">
                            <a
                              :title="data.product_name"
                              v-if="data.review_link"
                              :href="getRouteLink(data.review_link, 'review')"
                              class="casino-title text-hover"
                              >{{
                                getPartnerGlobalString(
                                  $root.i18n.partner_name_review,
                                  data.product_name
                                )
                              }}</a
                            >
                            <span class="emt-sp" v-else>&nbsp;</span>
                          </template>
                          <template v-else>
                            <router-link
                              :title="data.product_name"
                              v-if="data.review_link"
                              :to="getRouteLink(data.review_link, 'review')"
                              class="casino-title text-hover"
                              >{{
                                getPartnerGlobalString(
                                  $root.i18n.partner_name_review,
                                  data.product_name
                                )
                              }}</router-link
                            >
                            <span class="emt-sp" v-else>&nbsp;</span>
                          </template>
                          <StarRating
                            :rating="parseFloat((data.rating / 2).toFixed(1))"
                          />
                        </div>
                      </div>
                      <div class="play-card-mid">
                        <span class="span-h5 custom-font-1 game-bonus-text">
                          <template v-if="hideBonusLabelGB">
                            <span>{{ $root.i18n.hidden_partner_bonus }}</span>
                          </template>
                          <template v-else>
                            <a
                              :title="data.product_name"
                              :href="getGoLink(data.go_link, data.slug)"
                              class="bonus-link custom-font-1 cas-link"
                              target="_blank"
                              :rel="
                                $root.change_cta_to_sponsored
                                  ? 'nofollow sponsored'
                                  : 'nofollow'
                              "
                              :style="{
                                '--color-hover': $root.color_schema.primary_btn,
                              }"
                            >
                              <span
                                v-if="
                                  data.bonus_match &&
                                  data.exclusive_bonus_amount &&
                                  data.exclusive_bonus_match
                                "
                                >{{ data.exclusive_bonus_match }}%
                                {{ $root.i18n.match_bonus_up_to }}
                                {{
                                  data.exclusive_bonus_amount
                                    | currency(data.bonus_currency)
                                }}</span
                              >
                              <span
                                v-if="
                                  data.bonus_match &&
                                  !data.exclusive_bonus_amount &&
                                  data.bonus_amount
                                "
                                >{{ data.bonus_match }}%
                                {{ $root.i18n.match_bonus_up_to }}
                                {{
                                  data.bonus_amount
                                    | currency(data.bonus_currency)
                                }}</span
                              >
                              <span v-if="data.freespin || data.freebie_name">
                                <template
                                  v-if="
                                    (data.exclusive_bonus_amount ||
                                      data.bonus_amount) &&
                                    data.bonus_match
                                  "
                                  >+</template
                                >
                                <template v-if="data.freespin">
                                  <template
                                    v-if="data.show_freebie_currency === '1'"
                                    >{{
                                      data.freespin
                                        | currency(data.bonus_currency)
                                    }}</template
                                  >
                                  <template v-else>{{
                                    data.freespin
                                  }}</template>
                                  {{ data.freebie_name }}
                                </template>
                                <template v-else>{{
                                  data.freebie_name
                                }}</template>
                              </span>
                            </a>
                          </template>
                        </span>
                      </div>
                      <a
                        :title="data.product_name"
                        :href="getGoLink(data.go_link, data.slug)"
                        :class="{
                          'cta cta-primary cta-promotion cta-block custom-btn cta-game-large hover-btn cas-link': true,
                          'text-white':
                            !$root.override_ctabtntxt_color &&
                            !getContrastYIQ($root.color_schema.primary_btn),
                          'text-gray':
                            !$root.override_ctabtntxt_color &&
                            getContrastYIQ($root.color_schema.primary_btn),
                          'text-cta-override': $root.override_ctabtntxt_color,
                        }"
                        target="_blank"
                        :rel="
                          $root.change_cta_to_sponsored
                            ? 'nofollow sponsored'
                            : 'nofollow'
                        "
                        :style="{
                          '--primary-btn': $root.color_schema.primary_btn,
                          '--primary-btn-hover': pSBC(
                            -0.2,
                            $root.color_schema.primary_btn
                          ),
                        }"
                      >
                        <span class="cta-text">
                          <img
                            :src="crownIcon"
                            alt="Crown"
                            height="16"
                            width="24"
                            v-if="index === 0"
                          />
                          {{ data.cta_button_text }}</span
                        >
                        <span
                          class="hover-text"
                          v-for="(char, indexGo) in $root.i18n.go_to_casino"
                          :key="indexGo + `gamcpp`"
                          >{{ char }}</span
                        >
                      </a>
                      <div
                        class="gm-terms"
                        v-if="
                          (data.bonus_tc && data.bonus_tc != '') ||
                          (data.terms && data.terms != '')
                        "
                      >
                        <span
                          class="cas-term game-terms-text"
                          style="text-align: center"
                          v-if="data.bonus_tc && data.bonus_tc != ''"
                          v-html="data.bonus_tc.trim()"
                          :style="{
                            '--primary-btn': $root.color_schema.primary_btn,
                          }"
                        ></span>
                        <span
                          class="card-stroke"
                          v-if="
                            data.bonus_tc &&
                            data.terms &&
                            data.bonus_tc != '' &&
                            data.terms != ''
                          "
                          >|</span
                        >
                        <a
                          :rel="
                            $root.change_cta_to_sponsored
                              ? 'nofollow sponsored'
                              : 'nofollow'
                          "
                          class="cas-term game-terms-text"
                          v-if="data.terms && data.terms != ''"
                          :title="data.product_name"
                          :href="getGoLink(data.term_link, data.slug)"
                          target="_blank"
                          >{{ data.terms }}</a
                        >
                      </div>
                    </div>
                  </div>
                </div>
              </template>
            </template>
            <template v-else>
              <div
                class="live-dealer"
                v-if="
                  this.gamespageData.meta.play_with_live_dealer &&
                  this.gamespageData.meta.play_with_live_dealer.banner
                "
              >
                <template v-if="hideToplistLabelGB"> </template>
                <template v-else>
                  <a
                    v-if="
                      this.gamespageData.meta.geo_provider_partners_data &&
                      this.gamespageData.meta.geo_provider_partners_data.current
                    "
                    :title="
                      this.gamespageData.meta.geo_provider_partners_data.current
                        .product_name
                    "
                    :href="
                      getGoLink(
                        this.gamespageData.meta.geo_provider_partners_data
                          .current.go_link,
                        this.gamespageData.meta.geo_provider_partners_data
                          .current.slug
                      )
                    "
                    class="bg-link cas-link"
                    target="_blank"
                    :rel="
                      $root.change_cta_to_sponsored
                        ? 'nofollow sponsored'
                        : 'nofollow'
                    "
                  />
                </template>
                <img
                  v-if="$root.enable_lazyload"
                  v-lazy="this.gamespageData.meta.play_with_live_dealer.banner"
                  :alt="
                    getAltText(
                      this.gamespageData.meta.play_with_live_dealer.title,
                      this.gamespageData.meta.play_with_live_dealer.banner
                    )
                  "
                />
                <img
                  v-else
                  :src="this.gamespageData.meta.play_with_live_dealer.banner"
                  :alt="
                    getAltText(
                      this.gamespageData.meta.play_with_live_dealer.title,
                      this.gamespageData.meta.play_with_live_dealer.banner
                    )
                  "
                />
                <div class="live-dealer-content">
                  <div class="top-cont">
                    <span class="span-h2 custom-font-1">{{
                      this.gamespageData.meta.play_with_live_dealer.title
                    }}</span>
                    <div class="rating-wrapper-large">
                      <StarRating
                        :rating="
                          parseFloat(
                            this.gamespageData.meta.play_with_live_dealer.rating
                          )
                        "
                        no-text
                      />
                    </div>
                    <div class="rating-wrapper">
                      <div class="radio-stars radio-stars-mob">
                        <img
                          v-for="index in getRoundedRating(
                            parseFloat(
                              this.gamespageData.meta.play_with_live_dealer
                                .rating
                            )
                          )"
                          :key="index"
                          :src="
                            $root.site_url +
                            $root.asset_path +
                            '/svg-icons/star-mob.svg'
                          "
                          alt="Star Mobile"
                        />
                        <img
                          v-for="index in 5 -
                          getRoundedRating(
                            parseFloat(
                              this.gamespageData.meta.play_with_live_dealer
                                .rating
                            )
                          )"
                          :key="index + 10"
                          :src="
                            $root.site_url +
                            $root.asset_path +
                            '/svg-icons/star-mob-clr.svg'
                          "
                          alt="Star Mobile Clear"
                        />
                      </div>
                    </div>
                  </div>
                  <template v-if="hideToplistLabelGB"> </template>
                  <template v-else>
                    <a
                      v-if="
                        this.gamespageData.meta.geo_provider_partners_data &&
                        this.gamespageData.meta.geo_provider_partners_data
                          .current
                      "
                      :title="
                        this.gamespageData.meta.geo_provider_partners_data
                          .current.product_name
                      "
                      :href="
                        getGoLink(
                          this.gamespageData.meta.geo_provider_partners_data
                            .current.go_link,
                          this.gamespageData.meta.geo_provider_partners_data
                            .current.slug
                        )
                      "
                      target="_blank"
                      :rel="
                        $root.change_cta_to_sponsored
                          ? 'nofollow sponsored'
                          : 'nofollow'
                      "
                      :class="{
                        'cta cta-primary cta-yellow cta-yellow__lg z-index-2 custom-btn hover-btn cas-link': true,
                        'font-dark': getContrastYIQ(
                          $root.color_schema.primary_btn
                        ),
                        'font-light': !getContrastYIQ(
                          $root.color_schema.primary_btn
                        ),
                      }"
                      :style="{
                        '--primary-btn': $root.color_schema.primary_btn,
                        '--primary-btn-hover': pSBC(
                          -0.2,
                          $root.color_schema.primary_btn
                        ),
                      }"
                      ><span class="cta-text">{{
                        this.gamespageData.meta.play_with_live_dealer
                          .button_label
                      }}</span
                      ><span
                        class="hover-text"
                        v-for="(char, indexGo) in $root.i18n.go_to_casino"
                        :key="indexGo + `gambsdpp`"
                        >{{ char }}</span
                      >
                      <!--<span
                    class="hover-text"
                    v-for="(char,
                    indexPro) in this.gamespageData.meta.geo_provider_partners_data.current.product_name.split(
                      ''
                    )"
                    :key="indexPro + `gambsd`"
                    >{{ char }}</span
                  >--></a
                    >
                  </template>
                </div>
              </div>

              <div
                class="expert-review"
                :style="{
                  backgroundColor: pSBC(0.1, $root.color_schema.footer_bg),
                }"
                v-if="
                  this.gamespageData.meta &&
                  this.gamespageData.meta.our_expert_review &&
                  Object.keys(this.gamespageData.meta.our_expert_review)
                    .length > 0 &&
                  this.gamespageData.meta.our_expert_review.reviewer_image
                "
              >
                <div class="expert-review-inner">
                  <span class="span-h2 custom-font-1">{{
                    this.gamespageData.meta.our_expert_review.title
                  }}</span>
                  <div class="expert-info">
                    <div class="expert-info-pic">
                      <img
                        v-if="$root.enable_lazyload"
                        v-lazy="
                          this.gamespageData.meta.our_expert_review
                            .reviewer_image
                        "
                        :alt="
                          getAltText(
                            this.gamespageData.meta.our_expert_review.title,
                            this.gamespageData.meta.our_expert_review
                              .reviewer_image
                          )
                        "
                      />
                      <img
                        v-else
                        :src="
                          this.gamespageData.meta.our_expert_review
                            .reviewer_image
                        "
                        :alt="
                          getAltText(
                            this.gamespageData.meta.our_expert_review.title,
                            this.gamespageData.meta.our_expert_review
                              .reviewer_image
                          )
                        "
                      />
                    </div>
                    <div class="expert-info-right">
                      <StarRating
                        :rating="
                          parseFloat(
                            this.gamespageData.meta.our_expert_review
                              .review_rating
                          )
                        "
                        no-text
                      />
                      <span class="span-h6 custom-font-1">{{
                        this.gamespageData.meta.our_expert_review.reviewer_name
                      }}</span>
                      <span
                        >{{ $root.i18n.reviewed_on }}
                        {{
                          this.gamespageData.meta.our_expert_review.review_date
                        }}</span
                      >
                    </div>
                  </div>
                  <div class="expert-review-bottom">
                    <span>
                      <img
                        :src="
                          $root.site_url +
                          $root.asset_path +
                          '/svg-icons/expert-icon.svg'
                        "
                        alt="Expert Icon"
                      />
                    </span>
                    <p class="custom-font-2">
                      {{
                        this.gamespageData.meta.our_expert_review.review_content
                      }}
                    </p>
                  </div>
                </div>
              </div>
            </template>
          </div>
        </div>
      </div>

      <div
        class="play-casino-section"
        v-if="
          this.gamespageData.meta &&
          this.gamespageData.meta.geo_provider_partners_data &&
          this.gamespageData.meta.geo_provider_partners_data.current &&
          !this.gameTemplate
        "
      >
        <div class="container mobile-scroll-container">
          <template v-if="hideToplistLabelGB">
            <div class="text-center pt-10 font-light">
              {{ $root.i18n.no_toplist_available_intime }}
            </div>
          </template>

          <template v-else>
            <template v-if="gamesTop3.length > 0">
              <div v-for="(val, index) in gamesTop3" :key="index">
                <!-- <span
                  v-if="val && val.length > 0"
                  :class="{
                    'span-h1 custom-font-1 cust-h1': true,
                    'font-light': !getContrastYIQ($root.color_schema.footer_bg),
                  }"
                  >{{ gamesTop3Title[index] }}</span
                > -->
                <TagBlock
                  v-if="val && val.length > 0"
                  :attrs="{}"
                  :title="gamesTop3Title[index]"
                  :block="'gamepageBanner'"
                  :usTag="
                    gamesTop3Attrs &&
                    gamesTop3Attrs.hasOwnProperty('title_tag') &&
                    gamesTop3Attrs.title_tag != ''
                      ? gamesTop3Attrs.title_tag
                      : 'span'
                  "
                />
                <div class="mobile-scroller">
                  <div class="row wd-auto">
                    <div
                      class="col-md-4 col-sm-4 mw-300"
                      v-for="(data, index) in val"
                      :key="index"
                    >
                      <div
                        :class="{
                          'play-card': true,
                          'term-recas':
                            (data.bonus_tc && data.bonus_tc != '') ||
                            (data.terms && data.terms != ''),
                          'top-choice': index === 0,
                          'rm-bottom-color':
                            index === 0 &&
                            ((data.bonus_tc && data.bonus_tc != '') ||
                              (data.terms && data.terms != '')),
                        }"
                      >
                        <div class="play-card-top">
                          <div class="play-card-top-img pos-relative">
                            <a
                              :title="data.product_name"
                              :href="getGoLink(data.go_link, data.slug)"
                              class="partner-logo cas-link"
                              :rel="
                                $root.change_cta_to_sponsored
                                  ? 'nofollow sponsored'
                                  : 'nofollow'
                              "
                              target="_blank"
                            >
                              <img
                                v-if="
                                  $root.enable_lazyload &&
                                  assets_images &&
                                  assets_images.pro_asset_sizes
                                "
                                v-lazy="
                                  data.product_assets.filter(
                                    (ele) =>
                                      ele.asset_category_name ===
                                      assets_images.pro_asset_sizes.medium
                                  ).length > 0
                                    ? data.product_assets.filter(
                                        (ele) =>
                                          ele.asset_category_name ===
                                          assets_images.pro_asset_sizes.medium
                                      )[0].url
                                    : ''
                                "
                                :alt="
                                  getAltText(
                                    data.product_name,
                                    data.product_assets.filter(
                                      (ele) =>
                                        ele.asset_category_name ===
                                        assets_images.pro_asset_sizes.medium
                                    ).length > 0
                                      ? data.product_assets.filter(
                                          (ele) =>
                                            ele.asset_category_name ===
                                            assets_images.pro_asset_sizes.medium
                                        )[0].url
                                      : ''
                                  )
                                "
                              />
                              <img
                                v-else-if="
                                  assets_images && assets_images.pro_asset_sizes
                                "
                                :src="
                                  data.product_assets.filter(
                                    (ele) =>
                                      ele.asset_category_name ===
                                      assets_images.pro_asset_sizes.medium
                                  ).length > 0
                                    ? data.product_assets.filter(
                                        (ele) =>
                                          ele.asset_category_name ===
                                          assets_images.pro_asset_sizes.medium
                                      )[0].url
                                    : $root.site_url +
                                      $root.asset_path +
                                      '/failure.png'
                                "
                                :alt="
                                  getAltText(
                                    data.product_name,
                                    data.product_assets.filter(
                                      (ele) =>
                                        ele.asset_category_name ===
                                        assets_images.pro_asset_sizes.medium
                                    ).length > 0
                                      ? data.product_assets.filter(
                                          (ele) =>
                                            ele.asset_category_name ===
                                            assets_images.pro_asset_sizes.medium
                                        )[0].url
                                      : $root.site_url +
                                          $root.asset_path +
                                          '/failure.png'
                                  )
                                "
                              />
                              <div class="partner-hover wd-gam-cas">
                                <div
                                  class="partner-hover-inner"
                                  :style="{
                                    '--primary-btn':
                                      $root.color_schema.primary_btn,
                                    '--primary-btn-hover': pSBC(
                                      -0.2,
                                      $root.color_schema.primary_btn
                                    ),
                                  }"
                                >
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="10"
                                    height="16"
                                    viewBox="0 0 10 16"
                                    fill="none"
                                  >
                                    <path
                                      d="M9.44469 7.37568L2.32449 0.255608C2.15981 0.090796 1.93997 0 1.70557 0C1.47116 0 1.25133 0.090796 1.08664 0.255608L0.562291 0.779831C0.22109 1.12142 0.22109 1.6766 0.562291 2.01767L6.5413 7.99668L0.555657 13.9823C0.390975 14.1471 0.300049 14.3668 0.300049 14.6011C0.300049 14.8357 0.390975 15.0554 0.555657 15.2203L1.08001 15.7444C1.24482 15.9092 1.46453 16 1.69893 16C1.93334 16 2.15317 15.9092 2.31785 15.7444L9.44469 8.61782C9.60976 8.45248 9.70043 8.23174 9.69991 7.99707C9.70043 7.7615 9.60976 7.54088 9.44469 7.37568Z"
                                      fill="white"
                                    />
                                  </svg>
                                </div>
                              </div>
                              <div
                                :class="{
                                  'stripe text-center': true,
                                  'font-dark': getContrastYIQ(
                                    Object.keys(hasTag(data.tags)).length > 0
                                      ? hasTag(data.tags).color
                                      : null
                                  ),
                                  'font-light': !getContrastYIQ(
                                    Object.keys(hasTag(data.tags)).length > 0
                                      ? hasTag(data.tags).color
                                      : null
                                  ),
                                }"
                                v-if="Object.keys(hasTag(data.tags)).length > 0"
                                :style="{
                                  backgroundColor:
                                    Object.keys(hasTag(data.tags)).length > 0
                                      ? hasTag(data.tags).color
                                      : null,
                                }"
                              >
                                <img
                                  :src="hasTag(data.tags).icon"
                                  width="18"
                                  height="12"
                                  alt="tag-icons"
                                />
                              </div>
                              <!--<div
                                :class="{
                                  stripe: hasTag(data.tags),
                                  'stripe-text text-center': true,
                                  'font-dark': getContrastYIQ(
                                    $root.color_schema.tag_bg
                                  ),
                                  'font-light': !getContrastYIQ(
                                    $root.color_schema.tag_bg
                                  ),
                                }"
                                v-if="index != 0 && data.tags"
                                :style="{
                                  backgroundColor:
                                    hasTag(data.tags) != ''
                                      ? $root.color_schema.tag_bg
                                      : 'none',
                                }"
                              >
                                {{ hasTag(data.tags) }}
                              </div>-->
                            </a>
                          </div>
                          <div class="play-card-top-right gamefree-casino">
                            <span class="span-h5 custom-font-1">
                              <template v-if="hideBonusLabelGB">
                                <span>{{
                                  $root.i18n.hidden_partner_bonus
                                }}</span>
                              </template>
                              <template v-else>
                                <a
                                  :title="data.product_name"
                                  :href="getGoLink(data.go_link, data.slug)"
                                  class="bonus-link custom-font-1 cas-link"
                                  target="_blank"
                                  :rel="
                                    $root.change_cta_to_sponsored
                                      ? 'nofollow sponsored'
                                      : 'nofollow'
                                  "
                                  :style="{
                                    '--color-hover':
                                      $root.color_schema.primary_btn,
                                  }"
                                >
                                  <span
                                    v-if="
                                      data.bonus_match &&
                                      data.exclusive_bonus_amount &&
                                      data.exclusive_bonus_match
                                    "
                                    >{{ data.exclusive_bonus_match }}%
                                    {{ $root.i18n.match_bonus_up_to }}
                                    {{
                                      data.exclusive_bonus_amount
                                        | currency(data.bonus_currency)
                                    }}</span
                                  >
                                  <span
                                    v-if="
                                      data.bonus_match &&
                                      !data.exclusive_bonus_amount &&
                                      data.bonus_amount
                                    "
                                    >{{ data.bonus_match }}%
                                    {{ $root.i18n.match_bonus_up_to }}
                                    {{
                                      data.bonus_amount
                                        | currency(data.bonus_currency)
                                    }}</span
                                  >
                                  <span
                                    v-if="data.freespin || data.freebie_name"
                                  >
                                    <template
                                      v-if="
                                        (data.exclusive_bonus_amount ||
                                          data.bonus_amount) &&
                                        data.bonus_match
                                      "
                                      >+</template
                                    >
                                    <template v-if="data.freespin">
                                      <template
                                        v-if="
                                          data.show_freebie_currency === '1'
                                        "
                                        >{{
                                          data.freespin
                                            | currency(data.bonus_currency)
                                        }}</template
                                      >
                                      <template v-else>{{
                                        data.freespin
                                      }}</template>
                                      {{ data.freebie_name }}
                                    </template>
                                    <template v-else>{{
                                      data.freebie_name
                                    }}</template>
                                  </span>
                                </a>
                              </template>
                            </span>
                            <div class="row mar-2">
                              <StarRating
                                :rating="
                                  parseFloat((data.rating / 2).toFixed(1))
                                "
                              />
                            </div>
                          </div>
                        </div>
                        <a
                          :title="data.product_name"
                          :href="getGoLink(data.go_link, data.slug)"
                          :class="{
                            'cta cta-primary cta-promotion cta-block custom-btn hover-btn cas-link': true,
                            'text-white':
                              !$root.override_ctabtntxt_color &&
                              !getContrastYIQ($root.color_schema.primary_btn),
                            'text-gray':
                              !$root.override_ctabtntxt_color &&
                              getContrastYIQ($root.color_schema.primary_btn),
                            'text-cta-override': $root.override_ctabtntxt_color,
                          }"
                          target="_blank"
                          :rel="
                            $root.change_cta_to_sponsored
                              ? 'nofollow sponsored'
                              : 'nofollow'
                          "
                          :style="{
                            '--primary-btn': $root.color_schema.primary_btn,
                            '--primary-btn-hover': pSBC(
                              -0.2,
                              $root.color_schema.primary_btn
                            ),
                          }"
                        >
                          <span class="cta-text">
                            <img
                              :src="crownIcon"
                              height="16"
                              width="24"
                              alt="Crown"
                              v-if="index === 0"
                            />
                            {{ data.cta_button_text }}</span
                          >
                          <span
                            class="hover-text"
                            v-for="(char, indexGo) in $root.i18n.go_to_casino"
                            :key="indexGo + `gamcpp`"
                            >{{ char }}</span
                          >
                        </a>
                        <template v-if="$root.enable_piwik_reload">
                          <a
                            :title="data.product_name"
                            v-if="data.review_link"
                            :href="getRouteLink(data.review_link, 'review')"
                            class="read-review"
                            >{{
                              getPartnerGlobalString(
                                $root.i18n.partner_name_review,
                                data.product_name
                              )
                            }}</a
                          >
                          <span class="emt-sp" v-else>&nbsp;</span>
                        </template>
                        <template v-else>
                          <router-link
                            :title="data.product_name"
                            v-if="data.review_link"
                            :to="getRouteLink(data.review_link, 'review')"
                            class="read-review"
                            >{{
                              getPartnerGlobalString(
                                $root.i18n.partner_name_review,
                                data.product_name
                              )
                            }}</router-link
                          >
                          <span class="emt-sp" v-else>&nbsp;</span>
                        </template>
                      </div>
                      <div
                        :class="{
                          'cas-terms gam-term': true,
                          'terms-top-choice':
                            index === 0 &&
                            ((data.bonus_tc && data.bonus_tc != '') ||
                              (data.terms && data.terms != '')),
                        }"
                        v-if="
                          (data.bonus_tc && data.bonus_tc != '') ||
                          (data.terms && data.terms != '')
                        "
                      >
                        <span
                          class="read-review cas-term"
                          style="text-align: center"
                          v-if="data.bonus_tc && data.bonus_tc != ''"
                          v-html="data.bonus_tc.trim()"
                          :style="{
                            '--primary-btn': $root.color_schema.primary_btn,
                          }"
                        ></span>
                        <span
                          class="card-stroke"
                          v-if="
                            data.bonus_tc &&
                            data.terms &&
                            data.bonus_tc != '' &&
                            data.terms != ''
                          "
                          >|</span
                        >
                        <a
                          :rel="
                            $root.change_cta_to_sponsored
                              ? 'nofollow sponsored'
                              : 'nofollow'
                          "
                          class="read-review cas-term"
                          v-if="data.terms && data.terms != ''"
                          :title="data.product_name"
                          :href="getGoLink(data.term_link, data.slug)"
                          target="_blank"
                          >{{ data.terms }}</a
                        >
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </template>
          </template>
        </div>
      </div>
    </section>
    <!-- End Game banner section -->

    <div
      :class="{
        'block-wrapper': true,
        'custom-background-image': $root.color_schema.site_bg_img,
      }"
      :style="{
        '--bg-image': `url(${$root.color_schema.site_bg_img}) repeat`,
        '--bg-color': $root.color_schema.site_bg_color,
      }"
    >
      <a
        class="main-tag cas-link"
        :href="getGoLink($root.goto_link, $root.slug)"
        v-if="$root.color_schema.site_bg_img"
        target="_blank"
        :rel="$root.change_cta_to_sponsored ? 'nofollow sponsored' : 'nofollow'"
      ></a>
      <div
        :class="{
          'custom-background-color': $root.color_schema.site_bg_img,
          'pb-25': true,
        }"
        v-observer:subtree="mutationObserve"
      >
        <section
          class="pt-26"
          v-if="
            !(this.gamespageData.meta && this.gamespageData.meta.banner_image)
          "
        >
          <div class="container z-con overflow-auto">
            <!--Breadcrumps-->
            <div class="col-md-12">
              <Breadcrumb
                :breadcrumbData="this.gamespageData.breadcrumb"
                :dark="true"
                :templateName="''"
                :gameBlockTitle="''"
              />
            </div>
            <!--End Breadcrumps-->
          </div>
        </section>
        <!-- Horizontal Cards -->
        <section
          :class="{
            'ct-card-horizontal-game': true,
            'pt-20':
              this.gamespageData.meta && this.gamespageData.meta.banner_image,
          }"
        >
          <template v-if="blockData">
            <template v-for="(data, index) in blockData">
              <CustomComponent :key="`${data.blockName}-${index}`" 
                :blockData="data" 
                :recommendSection="data.blockName === 'wpvcb/casino-toplist' && !data.attrs.style ? recommend_section : {}"
                :bluebar="data.blockName === 'wpvcb/casino-toplist' && (!data.attrs.style || data.attrs.style === 'ab_test_style') ? bluebar : {}"
                :blockIndex="index"
                />
            </template>
          </template>
        </section>
        <!-- Horizontal Cards ends -->
        <!--Related Page Links-->
        <template v-if="endOfblockData && morePaymentBottom">
          <RelatedLinks :relatedLinkData="morePaymentBottom" />
        </template>
        <!--End Related Page Links-->

        <!--Author Block-->
        <template v-if="auhtorBlockdata && endOfblockData"> </template>
        <!--End Author Block-->
      </div>
    </div>
  </main>
</template>

<script>
import StarRating from "@/components/ui/StarRating";
import CustomComponent from '@/components/CustomComponent'
import Breadcrumb from "@/components/layouts/Breadcrumb";
import RelatedLinks from "@/components/custom-block/RelatedLinks";
import IntroBlock from "@/components/custom-block/IntroBlock";
import NotFound from "@/pages/404";
import TagBlock from "@/components/custom-block/TagBlock";
import currency from "@/misc/currency";
import { metaChanger } from "@/misc/meta-changer";
import {
  pSBC,
  hexToRgb,
  getContrastYIQ,
  getOffset,
} from "@/misc/misc-function";
import { HttpService } from "@/api/Pages.api";
import fullscreen from "vue-fullscreen";
import Vue from "vue";
Vue.use(fullscreen);

export default {
  name: "GameFree",
  props: ["gamesData", "gameTemplate"],
  components: {
    StarRating,
    Breadcrumb,
    CustomComponent,
    RelatedLinks,
    IntroBlock,
    NotFound,
    TagBlock,
  },
  data: function () {
    return {
      gameTopHeaderTitle: "",
      gamespageData: {
        type: Array,
        default: () => [],
      },
      casinoTopList: {
        type: Array,
        default: () => [],
      },
      top_block: {
        type: Object,
        default: () => {},
      },
      assets_images: {
        type: Object,
        default: () => {},
      },
      morePaymentBottom: {
        type: Object,
        default: () => {},
      },
      gamesTop3: [],
      gamesTop3Title: [],
      gamesTop3Attrs: {},
      embedBlockNameList: [
        "core-embed/facebook",
        "core-embed/twitter",
        "core-embed/instagram",
        "core-embed/tumblr",
        "core-embed/tiktok",
      ],
      showData: true,
      blockData: [],
      blockDataIndex: 0,
      busy: false,
      endOfblockData: false,
      gameOverlay: false,
      hideBonusLabelGB: false,
      hideToplistLabelGB: false,
      scriptFlag: 0,
      auhtorBlockdata: [],
      rightBlockdata: [],
      introblockData: [],
      widthofgamesection: 0,
      typeCheck: "",
      bluebar: {},
      titleComponent: "",
      crownIcon: "",
    };
  },
  filters: {
    currency,
  },
  created: function () {
    if (
      this.$root.routes_meta[this.$route.params.postSlug] &&
      this.$root.routes_meta[this.$route.params.postSlug].metaTags
    )
      this.metaChanger(
        this.$root.routes_meta[this.$route.params.postSlug].metaTags
      );

    if (this.$root.hasPlay) {
      this.showData = false;
    } else {
      this.showData = true;
    }
    this.widthofgamesection = window.innerWidth;
    if (this.gamesData != undefined) {
      this.gamespageData = this.gamesData;

      // Schema Append
      document.getElementById("schema-script").innerHTML =
        this.gamespageData.schema;

      // Blocks Filtered
      let title = this.gamespageData.content.blocks.filter((ele) => {
        if (ele.blockName === "core/heading") {
          return ele.filtered_content;
        }
      });
      let content = this.gamespageData.content.blocks.filter((ele) => {
        if (ele.blockName === "core/paragraph") {
          return ele.filtered_content;
        }
      });
      let emoji_section = this.gamespageData.content.blocks.filter((ele) => {
        if (ele.blockName === "core/html") {
          return ele.filtered_content;
        }
      });
      this.top_block = { title, content, emoji_section };

      // Filter games top 3
      this.gamesTop3 = [];
      this.gamespageData.content.blocks.forEach(ele => {
        if (
          ele.blockName === "wpvcb/casino-toplist" &&
          ele.attrs &&
          ele.attrs.style === "gamepage_top_3"
        ) {
          this.gamesTop3.push(ele.filtered_content);
          this.gamesTop3Title.push(
            ele.attrs.block_title ? ele.attrs.block_title : ""
          );
          this.gamesTop3Attrs = ele.attrs;
        }
      });
      // Remove Games Top 3 from main blocks
      this.gamespageData.content.blocks = this.gamespageData.content.blocks.filter(ele => {
        if (
          ele.blockName === "wpvcb/casino-toplist" &&
          ele.attrs &&
          ele.attrs.style === "gamepage_top_3"
        ) {
          return false
        } else {
          return true
        }
      });

      // More Payments Bottom Card
      this.morePaymentBottom = this.gamespageData.meta.more_payment_method;

      // Author Blocks Filtered
      let atBlock = this.gamespageData.content.blocks.filter((ele) => {
        if (ele.blockName === "wpvcb/author-block") {
          return ele.filtered_content;
        }
      });
      if (atBlock.length > 0)
        this.auhtorBlockdata = atBlock.shift().filtered_content;

      // RightContent Blocks Filtered
      let rightBlock = this.gamespageData.content.blocks.filter((ele) => {
        if (ele.blockName === "wpvcb/right-content-simpletoc") {
          return ele.filtered_content;
        }
      });
      if (rightBlock.length > 0)
        this.rightBlockdata = rightBlock.shift().filtered_content;

      // Intro Block
      let introIndex = this.gamespageData.content.blocks.map((ele, index) => {
        if (ele.blockName === "wpvcb/intro-block") {
          return index;
        }
      })
      if (introIndex[0] != undefined) {
        this.introblockData = this.gamespageData.content.blocks[introIndex[0]].filtered_content;

        this.gamespageData.content.blocks.splice(introIndex[0], 1)
      }
      // Adminbar Data
      this.$root.adminBarData =
        Object.keys(this.gamespageData.toolbar).length > 0
          ? this.gamespageData.toolbar
          : "";
      this.$root.disable = this.$root.adminBarData
        ? this.$root.adminBarData.visible
        : false;

      // Assets Sizes
      this.assets_images =
        Object.keys(this.$root.asset_sizes).length > 0
          ? this.$root.asset_sizes
          : "";
      if (
        this.gamespageData.meta &&
        this.gamespageData.meta.geo_provider_partners_data &&
        this.gamespageData.meta.geo_provider_partners_data.current
      )
        this.getBonusShowHideGB(
          this.gamespageData.meta.geo_provider_partners_data.current
        );
    } else {
      this.$root.loading = true;
      this.gamespageData = {};
      this.getData();
    }

    this.titleComponent = this.gamesTop3Attrs &&
                      this.gamesTop3Attrs.hasOwnProperty('title_tag') &&
                      this.gamesTop3Attrs.title_tag != ''
                        ? this.gamesTop3Attrs.title_tag
                        : 'span';
  
    const assetPath = `${global.wpvue_script_data_params.site_url}/wp-content/themes/wpvue/src/assets/images`
    this.crownIcon = global.wpvue_script_data_params.data.site_data.theme_icons.crown || assetPath + '/svg-icons/crown.svg';
  },
  mounted: function () {
    var maxHeight = 0;
    document.querySelectorAll(".gamefree-casino").forEach((ele) => {
      if (maxHeight <= ele.offsetHeight) {
        maxHeight = ele.offsetHeight;
      }
    });

    document.querySelectorAll(".gamefree-casino").forEach((ele) => {
      ele.style.height = `${maxHeight}px`;
    });

    var maxTermHeight = 0;
    document.querySelectorAll(".gam-term").forEach((ele) => {
      if (maxTermHeight <= ele.offsetHeight) {
        maxTermHeight = ele.offsetHeight;
      }
    });

    document.querySelectorAll(".gam-term").forEach((ele) => {
      ele.style.height = `${maxTermHeight}px`;
    });

    var maxStickyHeight = 0;
    document.querySelectorAll(".sticky-review-card").forEach((ele) => {
      if (maxStickyHeight <= ele.offsetHeight) {
        maxStickyHeight = ele.offsetHeight;
      }
    });

    document.querySelectorAll(".sticky-review-card").forEach((ele) => {
      ele.style.height = `${maxStickyHeight}px`;
    });

    if (window.innerWidth > 991 && this.gameTemplate) {
      var maxGameRightHeight = 0;
      document.querySelectorAll(".game-right").forEach((ele) => {
        if (maxGameRightHeight <= ele.offsetHeight) {
          maxGameRightHeight = ele.offsetHeight;
        }
      });

      document.querySelectorAll(".game-left").forEach((ele) => {
        if (maxGameRightHeight > 557) {
          ele.style.height = `${maxGameRightHeight}px`;
        } else {
          ele.style.height = `${557}px`;
        }
      });
    }

    if (Object.keys(this.gamespageData).length > 0) {
      //if (!this.$root.enable_lazyload) {
      this.blockData = this.gamespageData.content.blocks;
      this.blockDataIndex = this.gamespageData.content.blocks.length;
      this.$root.show_footer = true;
      // } else {
      //   if (this.gamespageData.content.blocks.length > 0) {
      //     this.incrementBlockDataValue();
      //     this.$root.show_footer = false;
      //   } else {
      //     this.$root.show_footer = true;
      //   }
      // }
    }

    if (
      this.scriptFlag === 0 &&
      this.gamespageData.content.blocks.filter((ele) => {
        return (
          ele.blockName === "wpvcb/custom-youtube" ||
          ele.blockName === "wpvcb/youtube-film-strip"
        );
      }).length > 0
    ) {
      this.youtubeInit();
      this.scriptFlag++;
    }

    this.$nextTick(() => this.heightCheck());
    var that = this;
    window.addEventListener(
      "scroll",
      () => {
        that.heightCheck();
      },
      { passive: true }
    );
    window.addEventListener("resize", () => {
      this.widthofgamesection = window.innerWidth;
      that.heightCheck();
      that.iframeShowHideEvent();
      that.stopScrollCheck();
      if (!this.showData) that.openFullscreen();
    });

    const meta = this.gamespageData.meta;
    
    if (meta.bluebar) {
      this.bluebar = meta.bluebar;
    } else {
      this.bluebar = {};
    }
  },
  beforeDestroy() {
    this.$root.hasPlay = false;
    this.showData = true;
    this.iframeShowHideEvent();
    window.removeEventListener(
      "scroll",
      () => {
        that.heightCheck();
      },
      { passive: true }
    );
    window.removeEventListener("resize", () => {
      that.heightCheck();
      that.iframeShowHideEvent();
      that.stopScrollCheck();
      that.openFullscreen();
    });

    document.getElementById("app").classList.remove("no-scroll");
  },
  watch: {
    $route: function () {
      if (this.$root.hasPlay) {
        this.showData = false;
      } else {
        this.showData = true;
      }
      if (this.gamesData != undefined) {
      } else {
        this.$root.loading = true;
        this.gamespageData = {};
        this.getData();
      }
      this.gamespageData = "";
    },
    blockData: function () {
      if (this.blockData.length === this.gamespageData.content.blocks.length) {
        this.$root.show_footer = true;
      }
    },
    showData: function () {
      this.iframeShowHideEvent();
      if (this.showData)
        document.getElementById("app").classList.remove("no-scroll");
      else this.stopScrollCheck();
    },
  },
  computed: {
    color: function () {
      let rgb = this.hexToRgb("#060236");
      return `rgba(${rgb.r},${rgb.g},${rgb.b}, 0.8)`;
    },
  },
  methods: {
    pSBC,
    hexToRgb,
    getContrastYIQ,
    metaChanger,
    getOffset,
    heightCheck: function () {
      let appDOM = document.getElementById("app");
      let windowHeight = window.innerHeight;
      let appBottom = appDOM.scrollHeight - windowHeight - window.pageYOffset;
      if (appBottom < windowHeight / 2) {
        this.loadMore();
      }
    },
    // Infinite scroll Height Checking
    mutationObserve: function (mutations) {
      if (
        Object.keys(this.gamespageData).length > 0 &&
        this.blockData.length < this.gamespageData.content.blocks.length
      ) {
        let appHeight = document.getElementById("app").offsetHeight;
        if (appHeight < window.innerHeight) {
          this.blockData = this.gamespageData.content.blocks.slice(
            0,
            this.blockDataIndex + 1
          );
          this.blockDataIndex++;
          this.heightCheck();
        }
      }
    },
    // Infinite scroll load more
    loadMore: function () {
      if (
        Object.keys(this.gamespageData).length > 0 &&
        this.blockData.length < this.gamespageData.content.blocks.length
      ) {
        this.busy = true;
        this.blockData = this.gamespageData.content.blocks.slice(
          0,
          this.blockDataIndex + 1
        );
        this.blockDataIndex++;
        this.busy = false;
        //this.heightCheck();
      } else {
        this.endOfblockData = true;
      }
    },
    incrementBlockDataValue: function () {
      if (
        this.gamespageData &&
        this.gamespageData.content.blocks &&
        !(
          this.gamespageData.meta &&
          this.gamespageData.meta.geo_provider_partners_data &&
          this.gamespageData.meta.geo_provider_partners_data.current
        )
      ) {
        this.blockData = this.gamespageData.content.blocks.slice(
          0,
          this.blockDataIndex + 1
        );
        this.blockDataIndex++;
      }
    },
    todo: function () {
      const self = this;
      this.intervalid1 = setTimeout(function () {
        if (window.innerWidth >= 320) {
          let stickyShow = document.getElementById("game_review_flex");
          self.gameOverlay = true;
          stickyShow.style.display = "none";
          if (window.innerWidth > 991 && self.gameTemplate) {
            var maxGameRightHeight = 0;
            document.querySelectorAll(".game-right").forEach((ele) => {
              if (maxGameRightHeight <= ele.offsetHeight) {
                maxGameRightHeight = ele.offsetHeight;
              }
            });
            document.querySelectorAll(".wrapper-game-iframe").forEach((ele) => {
              if (maxGameRightHeight > 557) {
                ele.style.height = `${maxGameRightHeight - 8}px`;
              } else {
                ele.style.height = `${557}px`;
              }
            });
            document.querySelectorAll(".game-space").forEach((ele) => {
              if (maxGameRightHeight > 557) {
                ele.style.height = `${maxGameRightHeight - 8}px`;
              } else {
                ele.style.height = `${557}px`;
              }
            });
          } else {
            if (
              this.gamespageData.meta &&
              this.gamespageData.meta.enable_different_free_game_url_for_mobile
            ) {
              document.querySelectorAll(".wrapper-iframe").forEach((ele) => {
                if (maxGameRightHeight > 557) {
                  ele.style.height = `${maxGameRightHeight - 8}px`;
                } else {
                  ele.style.height = `${557}px`;
                }
              });
            }
          }
        }
      }, this.$root.game_overlay_screen_time * 1000);
    },
    overlayHide: function () {
      this.gameOverlay = false;
      if (window.innerWidth > 991 && this.gameTemplate) {
        var maxGameRightHeight = 0;
        document.querySelectorAll(".game-right").forEach((ele) => {
          if (maxGameRightHeight <= ele.offsetHeight) {
            maxGameRightHeight = ele.offsetHeight;
          }
        });
        document.querySelectorAll(".wrapper-game-iframe").forEach((ele) => {
          if (maxGameRightHeight > 557) {
            ele.style.height = `${maxGameRightHeight - 90 - 8}px`;
          } else {
            ele.style.height = `${557 - 90}px`;
          }
        });

        if (this.gamesTop3 && this.gamesTop3.length > 0) {
          document.querySelectorAll(".game-space").forEach((ele) => {
            if (maxGameRightHeight > 557) {
              ele.style.height = `${maxGameRightHeight - 90 - 8}px`;
            } else {
              ele.style.height = `${557 - 90}px`;
            }
          });
        } else {
          document.querySelectorAll(".game-space").forEach((ele) => {
            ele.style.height = `${557 + 90}px`;
          });
        }
      }
      let stickyShow = document.getElementById("game_review_flex");
      stickyShow.style.display = "block";
    },
    getData() {
      HttpService.getBody(
        this.$root.wp_country && this.$root.wp_country != ""
          ? this.$root.wp_country
          : this.$cookies.get("wp-country"),
        this.$root.wp_state && this.$root.wp_state != ""
          ? this.$root.wp_state
          : this.$cookies.get("wp-state"),
        this.$route.params.postSlug,
        this.$root.user_id
      )
        .then((res) => {
          this.gamespageData = res.data.data;

          // Schema Append
          document.getElementById("schema-script").innerHTML =
            this.gamespageData.schema;

          // Blocks Filtered
          let title = this.gamespageData.content.blocks.filter((ele) => {
            if (ele.blockName === "core/heading") {
              return ele.filtered_content;
            }
          });
          let content = this.gamespageData.content.blocks.filter((ele) => {
            if (ele.blockName === "core/paragraph") {
              return ele.filtered_content;
            }
          });
          let emoji_section = this.gamespageData.content.blocks.filter(
            (ele) => {
              if (ele.blockName === "core/html") {
                return ele.filtered_content;
              }
            }
          );
          this.top_block = { title, content, emoji_section };

          // Filter games top 3
          this.gamesTop3 = [];
          this.gamespageData.content.blocks.forEach(ele => {
            if (
              ele.blockName === "wpvcb/casino-toplist" &&
              ele.attrs &&
              ele.attrs.style === "gamepage_top_3"
            ) {
              this.gamesTop3.push(ele.filtered_content);
              this.gamesTop3Title.push(
                ele.attrs.block_title ? ele.attrs.block_title : ""
              );
              this.gamesTop3Attrs = ele.attrs;
            }
          });
          // Remove Games Top 3 from main blocks
          this.gamespageData.content.blocks = this.gamespageData.content.blocks.filter(ele => {
            if (
              ele.blockName === "wpvcb/casino-toplist" &&
              ele.attrs &&
              ele.attrs.style === "gamepage_top_3"
            ) {
              return false
            } else {
              return true
            }
          });

          // More Payments Bottom Card
          this.morePaymentBottom = this.gamespageData.meta.more_payment_method;

          // Author Blocks Filtered
          let atBlock = this.gamespageData.content.blocks.filter((ele) => {
            if (ele.blockName === "wpvcb/author-block") {
              return ele.filtered_content;
            }
          });
          if (atBlock.length > 0)
            this.auhtorBlockdata = atBlock.shift().filtered_content;

          // RightContent Blocks Filtered
          let rightBlock = this.gamespageData.content.blocks.filter((ele) => {
            if (ele.blockName === "wpvcb/right-content-simpletoc") {
              return ele.filtered_content;
            }
          });
          if (rightBlock.length > 0)
            this.rightBlockdata = rightBlock.shift().filtered_content;

          // Intro Block
          let introIndex = this.gamespageData.content.blocks.map((ele, index) => {
            if (ele.blockName === "wpvcb/intro-block") {
              return index;
            }
          })
          if (introIndex[0] != undefined) {
            this.introblockData = this.gamespageData.content.blocks[introIndex[0]].filtered_content;

            this.gamespageData.content.blocks.splice(introIndex[0], 1)
          }
          // Adminbar Data
          this.$root.adminBarData =
            Object.keys(this.gamespageData.toolbar).length > 0
              ? this.gamespageData.toolbar
              : "";
          this.$root.disable = this.$root.adminBarData
            ? this.$root.adminBarData.visible
            : false;

          // Assets Sizes
          this.assets_images =
            Object.keys(this.$root.asset_sizes).length > 0
              ? this.$root.asset_sizes
              : "";
          if (
            this.gamespageData.meta &&
            this.gamespageData.meta.geo_provider_partners_data &&
            this.gamespageData.meta.geo_provider_partners_data.current
          )
            this.getBonusShowHideGB(
              this.gamespageData.meta.geo_provider_partners_data.current
            );
          //if (!this.$root.enable_lazyload) {
          this.blockData = this.gamespageData.content.blocks;
          this.blockDataIndex = this.gamespageData.content.blocks.length;
          this.$root.show_footer = true;
          // } else {
          //   if (this.gamespageData.content.blocks.length > 0) {
          //     this.incrementBlockDataValue();
          //     this.$root.show_footer = false;
          //   } else {
          //     this.$root.show_footer = true;
          //   }
          // }
          this.$root.loading = false;
          this.$root.body_loading_status = true;
        })
        .catch((err) => {
          this.typeCheck = "error";
          this.$root.loading = false;
        });
    },
    itemFAQ: function (data) {
      let FAQitems = [];
      data.forEach((ele) => {
        let { id, faq_question: title, faq_answer: content } = ele;

        let is_active = false;
        if (ele.is_active === "1") {
          is_active = true;
        }

        FAQitems.push({ id, title, content, is_active });
      });
      return FAQitems;
    },
    showIframe: function () {
      this.showData = !this.showData;
      if (
        this.gamespageData.meta.geo_provider_partners_data &&
        this.gamespageData.meta.geo_provider_partners_data.current
      ) {
        this.todo();
      }
      if (window.innerWidth > 991 && this.gameTemplate) {
        var maxGameRightHeight = 0;
        document.querySelectorAll(".game-right").forEach((ele) => {
          if (maxGameRightHeight <= ele.offsetHeight) {
            maxGameRightHeight = ele.offsetHeight;
          }
        });
        document.querySelectorAll(".game-left").forEach((ele) => {
          if (maxGameRightHeight > 557) {
            ele.style.height = `${maxGameRightHeight - 90 - 8}px`;
          } else {
            ele.style.height = `${557 - 90}px`;
          }
        });
      }
      //this.openFullscreen();
    },
    getRoundedRating: function (rating) {
      if (rating - Math.floor(rating) >= 0.5) {
        return Math.ceil(rating);
      } else {
        return Math.floor(rating);
      }
    },
    checkOrientationLandscape: function () {
      return window.innerHeight < window.innerWidth;
    },
    iframeFull: function () {
      if (window.innerWidth <= 1200) {
        return this.checkOrientationLandscape();
      } else {
        return false;
      }
    },
    iframeShowHideEvent: function () {
      let appDom = document.getElementById("app");
      let header = document.getElementById("header");
      if (!this.showData) {
        if (window.innerWidth <= 1200) {
          if (this.checkOrientationLandscape()) {
            appDom.classList.add("iframe-full");
            header.classList.add("hide-header");
          } else {
            appDom.classList.remove("iframe-full");
            header.classList.remove("hide-header");
          }
        } else {
          appDom.classList.remove("iframe-full");
          header.classList.remove("hide-header");
        }
      } else {
        appDom.classList.remove("iframe-full");
        header.classList.remove("hide-header");
      }
    },
    stopScrollCheck: function () {
      if (
        !(
          this.gamespageData.meta &&
          this.gamespageData.meta.enable_different_free_game_url_for_mobile
        )
      ) {
        let appDom = document.getElementById("app");
        if (!this.showData) {
          if (window.innerWidth <= 1200) {
            if (this.checkOrientationLandscape()) {
              appDom.classList.remove("no-scroll");
            } else {
              appDom.classList.add("no-scroll");
            }
          } else {
            appDom.classList.remove("no-scroll");
          }
        }
      }
    },
    openFullscreen: function () {
      if (
        !(
          this.gamespageData.meta &&
          this.gamespageData.meta.enable_different_free_game_url_for_mobile
        )
      ) {
        if (
          window.innerWidth <= 1200 &&
          window.innerWidth > window.innerHeight
        ) {
          if (!this.$refs["fullscreen"].getState()) {
            this.$refs["fullscreen"].enter();
          }
        } else {
          if (this.$refs["fullscreen"].getState()) {
            this.$refs["fullscreen"].exit();
          }
        }
        if (window.innerWidth > 991 && this.gameTemplate) {
          var maxGameRightHeight = 0;
          document.querySelectorAll(".game-right").forEach((ele) => {
            if (maxGameRightHeight <= ele.offsetHeight) {
              maxGameRightHeight = ele.offsetHeight;
            }
          });
          document.querySelectorAll(".wrapper-game-iframe").forEach((ele) => {
            if (maxGameRightHeight > 557) {
              ele.style.height = `${maxGameRightHeight - 90 - 8}px`;
            } else {
              ele.style.height = `${557 - 90}px`;
            }
          });
        }
      }
    },
    getBonusShowHideGB: function (partner) {
      let hideBonus = this.getCASToplistShowHideData(partner);
      if (hideBonus.hide_bonus === "1") {
        this.hideBonusLabelGB = true;
      } else if (hideBonus.hide_toplist === "1") {
        this.hideToplistLabelGB = true;
      }
    },
  },
};
</script>

<style lang="less" scoped>
@import "~@/assets/less/base/variable";

.wrapper-iframe {
  height: 557px;
}

.wrapper-game-iframe {
  height: 487px;
}

.banner-img {
  height: 557px;
}

.banner-img-im {
  height: 557px !important;
}

.cas-iframe {
  min-width: 100%;
  opacity: 1;
  border-radius: 0px 0px 10px 10px;
  height: 100%;
  width: 100%;
  overflow-x: hidden;
  transition: 0.5s;
  left: 0;
  top: 0;
  z-index: 5;
  position: relative;
  @media (max-width: @sizes[medium]) and (orientation: landscape) {
    position: fixed;
    z-index: 999;
  }
}

.z-con {
  @media (width: @sizes[medium]) {
    z-index: 8 !important;
  }
  @media (max-width: @sizes[small]) {
    z-index: 8 !important;
  }
}

.pos-relative {
  position: relative;
}

.mar-2 {
  margin-left: 2px;
}

.stripe {
  position: absolute;
  left: 0;
  width: 100%;
  height: 18px;
  bottom: 0;
  overflow: hidden;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #ffd039;
  border-bottom-left-radius: 7px;
  border-bottom-right-radius: 7px;
  &-text {
    display: flex;
    justify-content: center;
    align-items: center;
    font-weight: 600;
    font-size: 10px;
    line-height: 100%;
  }
  img {
    width: 18px !important;
    height: auto !important;
    margin: 3px auto;
    display: table;
    border-radius: 0 !important;
  }
}

.terms_tc {
  text-decoration: underline;
  color: @darkblue;
  font-size: 13px;
}

.pt-6px {
  padding-top: 6px;
}

.pt-3px {
  padding-top: 3px !important;
}

.ct {
  &-inner-banner {
    padding: 0px 0 45px;
    background: #070438 url(~@/assets/images/top-bg.svg) no-repeat 0 0;
    .game-space {
      position: relative;
      min-height: 321px;
      @media (min-width: @sizes[medium]) {
        height: auto;
        min-height: 557px;
      }
      img {
        border-radius: 10px;
        box-shadow: 0px 5px 15px rgba(0, 0, 0, 0.05);
        height: 100%;
        object-fit: cover;
        width: auto;
        max-height: 321px;
        min-height: 321px;
        @media (min-width: @sizes[extra-small]) {
          width: 100%;
          //max-height: none;
          min-height: auto;
        }
        @media (min-width: @sizes[medium]) {
          max-height: none;
        }
      }
      &-content {
        position: absolute;
        left: 0;
        right: 0;
        top: 0;
        bottom: 0;
        padding: 20px;
        background: rgba(0, 0, 0, 0.5);
        .border-radius(10px);
        .display-flex();
        .align-items(center);
        .justify-content-center();
        .flex-direction-column();
        .button-block {
          .display-flex();
          .align-items(center);
          .justify-content-center();
          .flex-direction-column();
          width: 100%;
          margin-bottom: 15px;
          margin-top: 5px;
          .cta {
            min-width: 100%;
            margin: 5px 0;
            font-weight: bold;
            font-size: 14px;
            line-height: 17px;
            padding: 10px 18px;
            @media (min-width: @sizes[medium]) {
              min-width: 330px;
              margin: 10px 0;
              padding: 15px 18px;
              font-size: 18px;
              line-height: 22px;
            }
          }
        }
        .game-logo {
          width: 136px;
          height: 136px;
          a {
            width: 136px;
            height: 136px;
            img {
              width: 136px;
              height: 136px;
              box-shadow: none;
              max-height: none;
              min-height: auto;
            }
          }
        }
      }
    }
    .row {
      .col-md-8 {
        @media (min-width: @sizes[medium]) {
          width: 100%;
          float: none;
        }
        @media (min-width: @sizes[large]) {
          width: 66.66666667%;
          float: left;
        }
      }
      .col-md-4 {
        @media (min-width: @sizes[medium]) {
          width: 100%;
          float: none;
        }
        @media (min-width: @sizes[large]) {
          width: 33.33333333%;
          float: left;
        }
      }
    }
    &-lft {
      margin-bottom: 19px;
      @media (min-width: @sizes[large]) {
        margin-bottom: 0;
      }
      @media (min-width: @sizes[extraX-large]) {
        width: 906px !important;
      }
    }
    &-rgt {
      @media (min-width: @sizes[extraX-large]) {
        width: 314px !important;
      }
    }
  }
}

.live-dealer {
  position: relative;
  height: 252px;
  margin-bottom: 0px;
  @media (min-width: @sizes[medium]) {
    margin-bottom: 17px;
  }
  &::before {
    content: "";
    position: absolute;
    height: 100%;
    width: 100%;
    border-radius: 12px;
    background: linear-gradient(
      180deg,
      #191923 0%,
      rgba(25, 25, 35, 0.610417) 41.67%,
      rgba(25, 25, 35, 0.15) 100%
    );
  }
  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    box-shadow: 0px 5px 15px rgba(0, 0, 0, 0.05);
    .border-radius(12px);
  }
  &-content {
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    .display-flex();
    .flex-direction-column();
    .align-items(center);
    .justify-content-space-between();
    padding-bottom: 25px;
    padding-top: 15px;
    @media (min-width: @sizes[medium]) {
      padding-bottom: 15px;
      padding-top: 5px;
    }
    h2 {
      color: @white;
      font-weight: 900;
      margin-bottom: 10px;
    }
    .span-h2 {
      color: @white;
      font-weight: 900;
      margin-bottom: 10px;
    }
    .rating-wrapper {
      .radio-stars {
        img {
          width: auto;
        }
        display: none;
        @media (min-width: @sizes[medium]) {
          display: block;
        }
        &-mob {
          display: flex;
          @media (min-width: @sizes[medium]) {
            display: none;
          }
        }
      }
    }
  }
}

.rating-wrapper-large {
  display: none;
  @media (min-width: @sizes[medium]) {
    display: block;
  }
}

.expert-review {
  box-shadow: 0px 5px 15px rgba(0, 0, 0, 0.05);
  .border-radius(12px);
  background: #08043e;
  display: none;
  @media (min-width: @sizes[medium]) {
    display: block;
  }
  @media (min-width: @sizes[large]) {
    background: url(~@/assets/images/bg.png) no-repeat -18px 0;
    background-size: 425px;
  }

  &-inner {
    padding: 16px 15px 12px;
  }
  h2 {
    color: #ffdd00;
    margin-bottom: 15px;
  }
  .span-h2 {
    color: #ffdd00;
    margin-bottom: 15px;
  }
  .expert-info {
    .display-flex();
    .align-items(start);
    margin-bottom: 10px;
    &-pic {
      width: 70px;
      height: 70px;
      .border-radius(100%);
      img {
        width: 100%;
        height: 100%;
        .border-radius(100%);
        object-fit: cover;
      }
    }
    &-right {
      text-align: left;
      padding-left: 15px;
      .rating-wrapper {
        margin-bottom: 10px;
        .align-items(start);
        .justify-content-flex-start();
      }
      h6 {
        font-weight: bold;
        color: @white;
        margin-bottom: 0px;
      }
      span {
        font-weight: bold;
        font-size: 12px;
        line-height: 112.95%;
        color: @altgray;
      }
    }
  }
  &-bottom {
    span {
      float: left;
      margin-right: 10px;
    }
    p {
      font-style: italic;
      font-weight: 300;
      color: @white;
      overflow: hidden;
      margin-bottom: 0;
    }
  }
}

.top-cont {
  text-align: center;
}

.play-casino-section {
  margin-top: 30px;
  h1 {
    color: @white;
    padding-left: 8px;
  }
}

.play-card {
  .border-radius(12px);
  background: @white;
  padding: 10px 15px 13px;
  border: 1px solid #9b9b9b;
  min-width: 280px;
  @media (min-width: @sizes[md-large]) {
    padding: 15px;
  }
  &.top-choice {
    border-color: @yellow;
  }
  &-top {
    .display-flex();
    .align-items(start);
    &-img {
      min-width: 68px;
      max-width: 68px;
      height: 68px;
      @media (min-width: @sizes[large]) {
        min-width: 72px;
        max-width: 72px;
        height: 72px;
      }
      img {
        width: 100%;
        height: 100%;
        .border-radius(8px);
        object-fit: cover;
      }
    }
    &-right {
      padding: 0 8px;
      white-space: normal;
      min-height: 100px;
      @media (min-width: @sizes[md-large]) {
        padding: 0 16px;
      }
      h5 {
        margin: 0px 0 5px 0;
        color: @lightdark;
      }
      .rating-wrapper {
        .align-items(center);
        .justify-content-flex-start();
      }
    }
  }
  .cta {
    margin-top: 0;
    padding: 17px 18px;
    font-size: 18px;
    line-height: 100%;
    @media (min-width: @sizes[md-large]) {
      padding: 17px 18px;
      font-size: 18px;
      line-height: 100%;
    }
    &:hover {
      background: @darkred;
      border-color: @darkred;
      color: @white;
      box-shadow: none;
      -webkit-box-shadow: none;
    }
  }
  .read-review {
    display: block;
    white-space: break-spaces;
    font-weight: normal;
    font-size: 14px;
    line-height: 150%;
    color: @lightdark;
    margin: 0 auto;
    text-decoration: underline;
    width: 240px;
    margin-top: 10px;
    text-align: center;
    @media (min-width: @sizes[sm-large]) {
      width: 350px;
    }
  }

  &-index {
    display: flex;
    justify-content: center;
    align-items: center;
    position: absolute;
    width: 17px;
    height: 17px;
    top: 0;
    left: 0;
    background: #DFE1E3;
    border-radius: 0 0px 2px;
    font-size: 12px;
    z-index: 1;
    font-weight: bolder;

    &-0 {
      background: #FFD03A;
    }
  }
}

.mt-35 {
  margin-top: 35px;
}

.ct {
  &-section {
    &-title {
      margin-top: 20px;
      .display-flex();
      .align-items(center);
      h2 {
        font-weight: 600;
        margin-bottom: 0;
        img {
          width: 18px;
          height: 18px;
        }
      }
    }
    &-link {
      position: relative;
      margin-top: 3px;
      margin-right: 13px;
      margin-left: auto;
      color: @blue;
      &:hover {
        .arrow {
          color: @black;
        }
      }
    }
  }
  &-online-casino {
    padding: 30px 0;
    h1.widget-title {
      margin-bottom: 15px;
    }
    .content {
      p {
        margin-bottom: 0;
      }
    }
  }
  &-online-casino-games {
    padding: 40px 0;
  }
  &-bonus-banner {
    padding: 30px 0;
  }
}

.casino-header {
  display: table;
  width: 100%;
  background: @darkblue;
  .border-radius(12px);
  h2 {
    text-align: center;
    color: @white;
    font-weight: bold;
    padding: 8px;
  }
}

.ct-card-horizontal {
  padding: 0;
  background-color: @light-gray;
  &-game {
    padding: 0;
    .casino-card-horizontal:first-child {
      margin-top: 20px;
    }
  }
}

.top-choice-card {
  width: fit-content;
  padding: 6px 10px;
  background: @yellow;
  text-align: center;
  display: table;
  .border-radius(5px);
  font-weight: bold;
  font-size: 12px;
  line-height: 97.44%;
  color: @lightdark;
  display: flex;
  justify-content: center;
  align-items: center;
  img {
    //margin-right: 5px;
    display: inline-block;
    //vertical-align: baseline;
    //width: 15px;
    width: 18px !important;
    height: 18px !important;
    border-radius: 0 !important;
    object-fit: contain !important;
    margin-right: 5px;
  }
}

.cta-yellow__lg {
  line-height: 38px;
  min-width: 270px;
  color: #fff !important;
  &:hover {
    color: #fff;
  }
}

.selection-cont {
  max-width: 960px;
}

.show_btn {
  margin-top: 0px !important;
  line-height: 22px;
}

.rating-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  .radio-stars-mob {
    background: rgba(246, 246, 246, 0.3);
    border-radius: 43.0894px;
    padding: 3px 5px;
    img {
      margin-right: 2px;
      border-radius: 0;
      width: auto;
    }
  }
}

.sticky-review-card {
  z-index: 9000;
  color: @white;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.05);
  transition: top 0.3s ease-out;
  border-radius: 10px 10px 0px 0px;
  padding: 3px 8px;
  display: none;
  .rating-wrapper-small {
    @media (min-width: @sizes[large]) {
      display: inline-flex;
      height: 24px;
      border-radius: 50px;
      margin-left: 15px;
      padding: 1px 7px;
      .radio-star-total {
        margin-left: 0;
      }
    }
  }
  .sticky-inner-wrapper {
    width: 100%;
    max-width: 78.125rem;
    padding: 10px;
    display: flex;
    align-items: center;
    border-radius: 10px;
    @media (min-width: @sizes[large]) {
      background: @white;
      position: relative;
    }
    .sticky-text {
      font-size: 0.75rem;
      div.termsgam {
        font-size: 12px;
        line-height: 160%;
      }
      .bonus-text {
        font-weight: 900;
        font-size: 0.75rem;
        a {
          color: @white;
        }
        @media (min-width: @sizes[medium]) {
          font-size: 0.85rem;
        }
        @media (min-width: @sizes[large]) {
          font-size: 1.075rem;
          a {
            color: @lightdark;
          }
        }
      }
      @media (min-width: @sizes[medium]) {
        font-size: 0.85rem;
      }
      @media (min-width: @sizes[large]) {
        margin-left: 0;
      }
      .terms-conditions {
        color: @white;
        @media (min-width: @sizes[large]) {
          color: @lightestp;
        }
      }
    }
    .affliate-logo {
      width: 65px;
      min-width: 65px;
      height: 65px;
      min-height: 65px;
      position: relative;
      margin-right: 15px;
      box-shadow: 0 5px 15px rgba(0, 0, 0, 0.09);
      img {
        border-radius: 12px;
      }
    }
    .sticky-play-btn {
      display: block;
      color: @white;
      box-shadow: none;
      margin: 0;
      min-width: 210px;
      margin-left: auto;
    }
  }
  @media (min-width: 769px) {
    min-height: 90px;
    background: @white;
    color: @lightdark;
    display: block;
  }
}

.pb-25 {
  padding-bottom: 25px;
}

.pt-37 {
  padding-top: 37px;
}

.helpful {
  background: @white;
  width: 100%;
  height: 101px;
  .display-flex();
  .align-items(center);
  .justify-content-space-between();
  padding: 27px 17px 27px 22px;
  margin: 25px 0 30px;
  .border-radius(12px);
  @media (min-width: @sizes[medium]) {
    .border-radius(0px);
  }
  @media (min-width: @sizes[large]) {
    margin: 45px 0 52px;
    padding: 33px 41px 33px 37px;
  }
  h3 {
    margin-bottom: 0;
  }
}

.hide-mob {
  display: none;
  @media (min-width: @sizes[medium]) {
    display: block;
  }
}

.casino-header {
  display: table;
  width: 100%;
  background: @darkblue;
  .border-radius(12px);
  h2 {
    text-align: center;
    color: @white;
    font-weight: bold;
    padding: 8px;
  }
}

.rotate {
  &-svg {
    margin-bottom: 20px;
    -webkit-animation: rotateRight 0.7s ease 1s forwards;
    -moz-animation: rotateRight 0.7s ease 1s forwards;
    animation: rotateRight 0.7s ease 1s forwards;
  }
  &-msg {
    position: absolute;
    top: 0;
    left: 0;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    display: flex;
    height: 100vh;
    z-index: 9;
    width: 100vw;
    background-color: #080438;
    background-color: var(--primary-bg);
    @media (orientation: landscape) {
      display: none;
    }

    @media (min-width: @sizes[large]) {
      display: none;
    }

    svg {
      fill: var(--primary-color);
      height: 110px;
    }

    span {
      color: var(--primary-color);
      font-size: 1.25rem;
      width: 75%;
      margin-bottom: 30px;
      opacity: 1;
      text-align: center;
    }

    .back-btn {
      color: var(--primary-color);
      border-color: var(--primary-color) !important;
      width: 80%;
      z-index: 10;
    }
  }
}

@-webkit-keyframes rotateRight {
  to {
    -webkit-transform: rotate(90deg);
    transform: rotate(90deg);
  }
}

@keyframes rotateRight {
  to {
    -webkit-transform: rotate(90deg);
    transform: rotate(90deg);
  }
}

.font-dark {
  color: @lightdark;
  svg {
    fill: @lightdark;
  }
}
.font-light {
  color: @white;
  svg {
    fill: @white;
  }
}

.pt-20 {
  padding-top: 20px !important;
}

.bonus-link {
  text-decoration: underline;

  span {
    display: block;
  }

  &:hover {
    color: var(--color-hover) !important;
    span {
      color: var(--color-hover) !important;
    }
  }
}

.gamefree-casino {
  &:hover {
    a {
      color: var(--hover-color);
    }
  }
}

.cta-yellow,
.cta-promotion {
  font-weight: 700 !important;
  font-size: 18px !important;
  line-height: 100% !important;
  padding: 17px 18px !important;
}

.bg-link {
  position: absolute;
  height: 100%;
  width: 100%;
  z-index: 1;
}

.game-logo,
.button-block a,
.z-index-2 {
  z-index: 2;
}

.banner-wd {
  width: 100% !important;
}

.mw-300 {
  min-width: 300px;
  @media (min-width: @sizes[large]) {
    min-width: auto;
  }
}

.iframe-full {
  .block-wrapper,
  .play-casino-section {
    display: none;
  }
}

.cta-overlay-enable-mobile {
  @media (min-width: @sizes[xx-small]) {
    display: flex !important;
    position: absolute;
    padding: 20px 0;
  }
  @media (min-width: @sizes[custom-small]) {
    display: flex !important;
    position: absolute !important;
    padding: 20px 0;
  }
  @media (min-width: @sizes[small]) {
    display: flex !important;
    position: fixed !important;
    padding: 20px 0;
  }
  img {
    width: 102px !important;
    min-height: 102px !important;
  }
  .text-wrapper {
    padding: 0 !important;
  }
}

.cta-overlay {
  top: 0px;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 1000;
  display: none;
  -webkit-box-align: center;
  align-items: center;
  -webkit-box-pack: center;
  justify-content: center;
  text-align: center;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  flex-direction: column;
  @media (min-width: @sizes[custom-small]) {
    display: flex;
    position: fixed;
    padding: 20px 0;
  }
  @media (min-width: @sizes[medium]) {
    top: 0;
  }
  @media (min-width: @sizes[large]) {
    position: absolute;
    top: 0;
  }

  .cta-promotion .best-rating {
    padding: 15px 0;
    .rating-wrapper {
      .rating-star-total {
        display: none;
      }
    }
  }
  .span {
    color: var(--primary-color) !important;
  }

  .how-about {
    color: var(--primary-color) !important;
    font-weight: 700;
    font-size: 1.25rem;
    line-height: 25px;
    display: flex;
    justify-content: center;
    width: 90%;
    @media (min-width: @sizes[medium]) {
      font-size: 1.75rem;
      line-height: 120%;
    }
    @media (min-width: @sizes[large]) {
      font-size: 1.75rem;
      line-height: 150%;
      width: 60%;
    }
  }

  .ct-btn {
    margin: 12px auto 0;
    @media (min-width: @sizes[large]) {
      margin: 25px auto 0;
    }
  }

  .back-btn {
    color: var(--primary-color);
    border-color: var(--primary-color) !important;
    z-index: 10;
    width: 100%;
  }

  .get-a {
    color: var(--primary-color);
    text-decoration: underline;
  }
}
.text-wrapper {
  width: 75%;
  padding: 0 45px;
  @media (min-width: @sizes[medium]) {
    width: 60%;
    margin: 0 auto;
  }
  @media (min-width: @sizes[large]) {
    width: 38%;
    margin: 0 auto;
  }
}

.img-cas {
  display: block;
  width: 102px;
  height: 102px;
  @media (min-width: @sizes[medium]) {
    display: block;
  }
  @media (min-width: @sizes[large]) {
    margin-bottom: 11px !important;
  }
}

.img-over {
  //width: 75% !important;
}

.cust-h1 {
  font-size: 26px;
  line-height: 31px;
}

.span-h5 {
  line-height: 160% !important;
  margin: 0 !important;
}

.term-recas {
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
}

.cas-terms {
  background: #dfe1e3;
  display: flex;
  padding: 5px 15px;
  margin: 0;
  width: 100%;
  font-weight: 400;
  color: @lightdark;
  min-height: 33px;
  border-bottom-left-radius: 12px;
  border-bottom-right-radius: 12px;
  line-height: 15px;
  font-size: 0.75rem;
  white-space: pre-wrap;
  min-width: 254px;
  box-shadow: 0 3px 4px rgba(0, 0, 0, 0.25);
  span {
    margin: auto 0;
  }
  @media (min-width: @sizes[medium]) {
    line-height: 18px;
    font-size: 0.75rem;
  }
}

.hover-btn {
  .cta-text {
    width: 100%;
  }
}

.rm-bottom-color {
  border-bottom-color: transparent !important;
}

.terms-top-choice {
  border: 2px solid #ffd039;
  border-top-color: transparent;
}

.emt-sp {
  display: block;
  margin-top: 6px;
}

.games-banner-block {
  .display-flex();
  .align-items(flex-start);
  .justify-content-space-between();
  .flex-direction-column();
  width: 100%;
  @media (min-width: @sizes[large]) {
    .flex-direction-row();
  }
  .ct-inner-banner-lft {
    width: 100%;
    margin-right: 0px;
    @media (min-width: @sizes[large]) {
      width: calc(100% - 320px);
      margin-right: 30px;
    }
  }
  .ct-inner-banner-rgt {
    min-width: 100%;
    max-width: 100%;
    @media (min-width: @sizes[large]) {
      min-width: 320px;
      max-width: 320px;
    }
    .span-h1 {
      font-weight: 900;
      color: @white;
      margin: 0px 0 16px 0;
      display: block;
      text-align: left;
      @media (min-width: @sizes[large]) {
        //margin: -42px 0 16px 0;
        text-align: center;
      }
    }
    .mobile-scroller {
      display: block;
      padding: 0;
      @media (min-width: @sizes[medium]) {
        .display-flex();
      }
      @media (min-width: @sizes[large]) {
        display: block;
      }
    }
  }
  .play-card {
    position: relative;
    .border-radius(8px);
    padding: 8px;
    margin-bottom: 16px;
    @media (min-width: @sizes[medium]) {
      margin-bottom: 0px;
      margin-right: 16px;
      min-width: 320px;
    }
    @media (min-width: @sizes[large]) {
      margin-right: 0px;
      margin-bottom: 16px;
    }
    &:last-child {
      margin-bottom: 0;
    }
    .top-choice-medal {
      position: absolute;
      right: 20px;
      top: 9px;
      img {
        max-width: 31px;
      }
    }
    &-top {
      margin-bottom: 14px;
      &-img {
        min-width: 40px;
        max-width: 40px;
        height: 40px;
      }
      &-right {
        padding: 0 12px;
        min-height: auto;
        .casino-title {
          font-weight: bold;
          font-size: 16px;
          line-height: 20px;
          letter-spacing: -0.03em;
          color: @lightdark;
          display: block;
          padding-right: 35px;
        }
      }
    }
    &-mid {
      margin-bottom: 8px;
      .bonus-link {
        font-weight: 900;
        font-size: 16px;
        line-height: 140%;
        text-align: center;
        color: #002844;
        display: inline-block;
        white-space: normal;
      }
    }
    .terms-text {
      margin-top: 8px;
      p {
        font-weight: normal;
        text-align: center;
        color: @lightestp;
        margin: 0;
      }
    }
  }
}

.game-terms-text {
  font-size: 12px !important;
  display: block;
  white-space: break-spaces;
  margin-top: 5px;
  line-height: 14px;
}

.gm-terms {
  a {
    cursor: pointer;
    text-decoration: underline !important;
    &:hover {
      color: var(--primary-btn);
    }
  }
}

.game-bonus-text {
  text-align: center;
}

.mob-game-title {
  display: block;
  @media (min-width: @sizes[large]) {
    display: none !important;
  }
}

.cta-game-large {
  display: block;
}

.stick-part-1 {
  min-width: 130px;
}

.stick-part-2 {
  padding: 0 10px;
}

.stripe-gam {
  display: block !important;
  text-align: center;
  span {
    font-size: 12px;
    line-height: 160%;
    font-weight: 700;
    display: flex;
    justify-content: center;
    align-items: center;
    height: 28px;
    img {
      margin-right: 5px;
    }
  }
  p {
    font-weight: 700;
  }
}

.stripe-gam {
  position: absolute;
  width: 100%;
  height: 28px;
  bottom: 0;
  left: 0;
  overflow: hidden;
  border-bottom-left-radius: 10px;
  border-bottom-right-radius: 10px;
  background-color: @yellow;
  display: none;
  @media (min-width: @sizes[small]) {
    display: block;
  }
  @media (max-width: @sizes[large]) {
    top: 50%;
    transform: translateY(41px);
    width: 136px;
  }
  img {
    width: 18px !important;
    height: 18px !important;
    border-radius: 0 !important;
    object-fit: contain !important;
  }
}

.stripe-gam-overlay {
  display: block !important;
  text-align: center;
  span {
    font-size: 12px;
    line-height: 160%;
    font-weight: 700;
    display: flex;
    justify-content: center;
    align-items: center;
    height: 28px;
    img {
      margin-right: 5px;
    }
  }
  p {
    font-weight: 700;
  }
}

.stripe-gam-overlay {
  position: absolute;
  //width: 100%;
  height: 28px;
  //bottom: 0;
  width: 100%;
  top: calc(100% - 28px);
  left: 0;
  //transform: translateY(17px);
  overflow: hidden;
  border-bottom-left-radius: 10px;
  border-bottom-right-radius: 10px;
  background-color: @yellow;
  display: none;
  @media (min-width: @sizes[small]) {
    display: block;
  }
  @media (min-width: @sizes[large]) {
    top: calc(100% - 28px);
    width: 102px;
  }
  img {
    width: 18px !important;
    height: 18px !important;
    border-radius: 0 !important;
    object-fit: contain !important;
  }
}

.gam-strp {
  position: relative;
}

.best-rating {
  margin-left: 8px;
  margin-top: 8px;
  margin-bottom: 5px;
  @media (min-width: @sizes[large]) {
    margin-top: 0px;
    margin-bottom: 0px;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/GameFree/GameFree.vue